/* =====================================================================
   Hubes Hub Custom Theme v1 — JS bundle
   Phase 1 only: announcement bar dismiss, mobile nav drawer.
   Cart drawer, predictive search, sticky vehicle banner ship in later
   phases. Keep this file small.

   Build sentinel: 2026-05-03-h3-prepop (forces content-hash refresh on
   Shopify CDN; H3 prePopulateFromStoredVehicle deployment from commit
   e703cec was not propagating despite "Theme upload complete"; bumping
   this comment to force content change → new asset_url ?v= cache-buster
   → fresh edge serve).
   ===================================================================== */

(function () {
  'use strict';

  // HHymm.configure at IIFE bootstrap (Pattern 4 race correction 2026-05-03).
  // Runs synchronously when hubeshub.js executes during defer phase: ymm.js
  // already defined window.HHymm (defer execution order); ready()-wrapped
  // init functions have not run yet (they're at the bottom of this IIFE).
  // Source URL passed via window-namespaced global set by inline <head>
  // script in layout/theme.liquid (Liquid asset_url interpolation lands in
  // the global before any defer execution).
  //
  // Defensive try/catch fall-through per Pattern 3: privacy modes, asset-
  // resolution edge cases, theme-editor transient states can throw. Existing
  // lazy-populate-on-focus path remains as the silent fallback if configure
  // fails or source is missing.
  if (window.HHymm && typeof window.HHymm.configure === 'function' && window.__hhYmmSource) {
    try { window.HHymm.configure({ source: window.__hhYmmSource }); } catch (e) { /* fall-through */ }
  }


  // Module-level reference to cart drawer's open/close API. Assigned by
  // initCartDrawer (3.5-1) at end of its setup; consumed by initAjaxAddToCart
  // (3.5-2) and future cart mutation handlers (3.5-3) to trigger drawer open
  // without relying on synthetic trigger.click() side effects.
  var cartDrawer = null;

  // ----- GA4 dataLayer helpers (3.5-5) -----
  // Per-pageview view_cart fire gate (Decision 1-A: single-fire per pageview).
  // Reset on bfcache restore via pageshow listener at bottom of IIFE.
  var viewCartFiredThisPageview = false;

  // item_brand sources from server-authoritative vendor (response for add_to_cart;
  // data-item-brand for DOM-read events). Different from PDP eyebrow which uses
  // custom.brand metafield with vendor fallback. Intentional: analytics is
  // response/server-driven; PDP UI is metafield-driven (richer brand display).
  // If vendor and custom.brand differ for some products, GA4 events show vendor
  // while PDP shows custom.brand. Don't sync them by adding metafield fetch to
  // events — different concerns.
  function buildCartItemFromLine (lineEl) {
    if (!lineEl) return null;
    var titleEl = lineEl.querySelector('.hh-cart-line__title');
    var qtyInput = lineEl.querySelector('[data-cart-qty-input]');
    return {
      item_id: lineEl.dataset.itemId || lineEl.dataset.lineKey || '',
      item_name: titleEl ? titleEl.textContent.trim() : '',
      item_brand: lineEl.dataset.itemBrand || '',
      price: parseFloat(lineEl.dataset.itemPrice) || 0,
      quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
    };
  }

  // Build full-cart items[] payload for view_cart + begin_checkout (Decision 7-A).
  // DOM-read from drawer or main-cart section (Decision 9-A); both render the
  // same cart-drawer-line-item snippet so item DOM shape is identical.
  function buildFullCartItems (rootEl) {
    if (!rootEl) return [];
    var lines = rootEl.querySelectorAll('.hh-cart-line');
    var items = [];
    Array.prototype.forEach.call(lines, function (line) {
      var item = buildCartItemFromLine(line);
      if (item) items.push(item);
    });
    return items;
  }

  // Read cart total from drawer or page subtotal element (Shopify-formatted "$X.XX").
  function readCartTotalFromDom (rootEl) {
    if (!rootEl) return 0;
    var subtotalEl = rootEl.querySelector('[data-cart-subtotal]');
    if (!subtotalEl) return 0;
    var text = subtotalEl.textContent.replace(/[^0-9.]/g, '');
    return parseFloat(text) || 0;
  }

  // dataLayer push helper — defensive init (per CLAUDE.md GA4 pattern;
  // analytics.liquid initializes dataLayer in head before this runs, but
  // belt-and-suspenders against future analytics-load reorder).
  function fireDataLayerEvent (eventName, ecommerce) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ecommerce: ecommerce
    });
  }

  // ---------------------------------------------------------------
  // Announcement bar — dismiss with localStorage persistence
  // ---------------------------------------------------------------
  function initAnnouncement() {
    var bar = document.querySelector('[data-hh-announce]');
    if (!bar) return;

    var key = bar.dataset.dismissKey || 'hh-announce-dismissed';
    var dismissed = false;
    try { dismissed = localStorage.getItem(key) === '1'; } catch (e) {}

    if (dismissed) {
      bar.hidden = true;
      return;
    }

    var closeBtn = bar.querySelector('[data-hh-announce-close]');
    if (!closeBtn) return;

    closeBtn.addEventListener('click', function () {
      bar.hidden = true;
      try { localStorage.setItem(key, '1'); } catch (e) {}
    });
  }

  // ---------------------------------------------------------------
  // Mobile nav drawer
  // ---------------------------------------------------------------
  function initMobileNav() {
    var drawer = document.querySelector('[data-hh-mobile-nav]');
    var openBtn = document.querySelector('[data-hh-mobile-nav-open]');
    var closeBtn = drawer && drawer.querySelector('[data-hh-mobile-nav-close]');
    if (!drawer || !openBtn || !closeBtn) return;

    function open() {
      drawer.dataset.open = 'true';
      // inert handles aria-hidden + removes focusables from tab order natively;
      // toggling inert via .inert property avoids the axe aria-hidden-focus
      // violation that came from setting aria-hidden on a drawer that contained
      // focusable descendants when closed.
      drawer.inert = false;
      document.body.style.overflow = 'hidden';
      // Focus the close button so screen readers land somewhere sensible
      window.requestAnimationFrame(function () { closeBtn.focus(); });
    }

    function close() {
      drawer.dataset.open = 'false';
      drawer.inert = true;
      document.body.style.overflow = '';
      openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    closeBtn.addEventListener('click', close);

    // Click on backdrop (drawer itself, but not the panel) closes
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });

    // Escape key closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.dataset.open === 'true') close();
    });
  }

  // ---------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ---------------------------------------------------------------
  // ---------------------------------------------------------------
  // initPdpGallery (Phase 2 main-image arrow nav, Jodi UAT 2026-05-10)
  //
  // Wires interactivity on top of the CSS-only radio+label gallery in
  // snippets/pdp-gallery.liquid. The CSS handles main-image fade
  // transitions + active-thumb visual indicator via radio :checked
  // sibling selectors. JS adds:
  //   - Click handlers on prev/next arrow buttons (overlay on main image)
  //   - Keyboard arrow nav when gallery has focus (Left/Right)
  //   - Touch swipe (basic threshold; horizontal-axis-only)
  //   - Wrap-around at gallery boundaries (last+next → first; first+prev → last)
  //   - Count display sync ("3 / 14") on selection change
  //
  // Mechanism: navigate(dir) flips the .checked state on radio inputs
  // (which fires the CSS sibling-selector chain that updates main image
  // + thumb border). Native change event dispatched for any listeners.
  // ---------------------------------------------------------------
  function initPdpGallery () {
    var galleries = document.querySelectorAll('.hh-pdp-gallery');
    galleries.forEach(function (g) {
      var inputs = g.querySelectorAll('.hh-pdp-gallery__thumb-input');
      if (inputs.length <= 1) return;
      var prevBtn = g.querySelector('[data-pdp-gallery-prev]');
      var nextBtn = g.querySelector('[data-pdp-gallery-next]');
      var countEl = g.querySelector('[data-pdp-gallery-count]');

      function findCheckedIdx () {
        for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return i;
        return 0;
      }

      function navigate (dir) {
        var idx = findCheckedIdx();
        var target = (idx + dir + inputs.length) % inputs.length;  // wrap-around
        inputs[target].checked = true;
        // Dispatch change for any listeners (count sync, analytics, etc.)
        inputs[target].dispatchEvent(new Event('change', { bubbles: true }));
      }

      function updateCount () {
        if (!countEl) return;
        countEl.textContent = (findCheckedIdx() + 1) + ' / ' + inputs.length;
      }

      // Click handlers — prev/next arrows
      if (prevBtn) prevBtn.addEventListener('click', function () { navigate(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { navigate(+1); });

      // Keyboard nav — Left/Right arrow keys when gallery container has focus
      g.addEventListener('keydown', function (e) {
        // Skip native radio focus traversal — radios handle Up/Down within
        // group; we only intercept Left/Right when target isn't an input.
        if (e.target.matches('input[type="radio"]')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); navigate(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); navigate(+1); }
      });

      // Touch swipe — bounded scope (50px threshold, horizontal axis only)
      var touchStartX = 0;
      var touchStartY = 0;
      var main = g.querySelector('.hh-pdp-gallery__main');
      if (main) {
        main.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        main.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          // Require horizontal swipe (|dx| > |dy|) above threshold
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            navigate(dx < 0 ? +1 : -1);
          }
        }, { passive: true });
      }

      // Count display sync — listen on each input for change events
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener('change', updateCount);
      }
      updateCount();  // initial state
    });
  }

  // ---------------------------------------------------------------
  // Click-to-copy (OEM PN, spec rows, alt part numbers)
  // Buttons use data-spec-copy. Source text comes from a sibling
  // [data-copy-text] attribute — the canonical value, preserved even
  // if the visible <code> wraps or truncates.
  // ---------------------------------------------------------------
  function initSpecCopy() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-spec-copy]');
      if (!btn) return;
      // Match either spec table rows OR PDP info-block PN block.
      var container = btn.closest('.hh-spec__row, .hh-pdp__pn');
      var src = container && container.querySelector('[data-copy-text]');
      var text = src ? src.getAttribute('data-copy-text') : '';
      if (!text || !navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(function () {
        btn.dataset.copied = 'true';
        setTimeout(function () { btn.dataset.copied = 'false'; }, 1500);
      });
    });
  }

  // ---------------------------------------------------------------
  // PDP quantity +/− buttons
  // Reads min/max from the input. Step is always 1.
  // ---------------------------------------------------------------
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-decrement], [data-qty-increment]');
      if (!btn) return;
      var qty = btn.closest('[data-qty]');
      var input = qty && qty.querySelector('[data-qty-input]');
      if (!input) return;
      var current = parseInt(input.value, 10);
      if (!Number.isFinite(current)) current = 1;
      var min = parseInt(input.min, 10);
      if (!Number.isFinite(min)) min = 1;
      var max = parseInt(input.max, 10);
      if (!Number.isFinite(max)) max = Infinity;
      var next = btn.matches('[data-qty-decrement]') ? Math.max(min, current - 1) : Math.min(max, current + 1);
      if (next !== current) {
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // ---------------------------------------------------------------
  // PDP variant pills
  // - Click updates aria-pressed on the option group's pills
  // - Resolves the variant matching the full option combination
  // - Updates the form's hidden id input + URL ?variant= param
  // - Dispatches CustomEvent('hh:variant-change', { detail: { variant } })
  //
  // Downstream listeners (price/stock/image swap, Stoq refresh) hook the
  // event without coupling to pill click logic. Variant data embedded
  // inline by pdp-info.liquid as <script data-product-variants>.
  // ---------------------------------------------------------------
  function initVariants() {
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.hh-pdp__variant-pill');
      if (!pill) return;
      if (pill.getAttribute('aria-disabled') === 'true') return;

      var pillsGroup = pill.closest('.hh-pdp__variant-pills');
      var form = pill.closest('form');
      if (!pillsGroup || !form) return;

      // Toggle aria-pressed within this option group
      Array.from(pillsGroup.querySelectorAll('.hh-pdp__variant-pill')).forEach(function (p) {
        p.setAttribute('aria-pressed', 'false');
        p.setAttribute('aria-checked', 'false');
      });
      pill.setAttribute('aria-pressed', 'true');
      pill.setAttribute('aria-checked', 'true');

      // Resolve current selection across ALL option groups in the form
      var optionGroups = Array.from(form.querySelectorAll('.hh-pdp__variants'));
      var selected = optionGroups.map(function (group) {
        var active = group.querySelector('[aria-pressed="true"]');
        return active ? active.getAttribute('data-option-value') : null;
      });

      // Look up matching variant from embedded JSON
      var dataEl = form.querySelector('[data-product-variants]') || document.querySelector('[data-product-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var match = variants.find(function (v) {
        return selected.every(function (val, idx) {
          return val === null || (v.options && v.options[idx] === val);
        });
      });
      if (!match) return;

      // Update form id input
      var idInput = form.querySelector('[data-variant-id-input]');
      if (idInput) idInput.value = match.id;

      // Update URL ?variant= without reload
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      } catch (err) { /* ignore */ }

      // Notify downstream listeners
      document.dispatchEvent(new CustomEvent('hh:variant-change', { detail: { variant: match } }));
    });
  }

  // ---------------------------------------------------------------
  // PDP fitment status — client upgrade
  //
  // Server renders the no-vehicle state. After page load (and on every
  // hh:vehicle-changed event from the vehicle-banner — Phase 2c), this
  // upgrades to fits / no-fit using HHymm.matches against the inlined
  // product fitment data.
  //
  // Server states the snippet ships with:
  //   - universal:    "Fits all vehicles" (universal_fitment="Yes" — overrides everything)
  //   - no-vehicle:   "Pick your vehicle to check fit" (default)
  // Client states this upgrades to:
  //   - fits:         "Fits your YYYY MAKE MODEL"
  //   - no-fit:       "Doesn't fit your YYYY MAKE MODEL — see the fitment table for compatible vehicles"
  // (verify-trim — Phase 2c+ refinement, when ambiguous trim signals exist)
  //
  // Definitive language by default; "May" reserved for genuine ambiguity.
  // ---------------------------------------------------------------
  var ICON_CHECK = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="20 6 9 17 4 12"/></svg>';

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function vehicleLabel(v) {
    if (!v) return '';
    return [v.year, v.make, v.model].filter(Boolean).join(' ');
  }

  function updateFitmentStatus() {
    var statusEl = document.querySelector('[data-fitment-status]');
    if (!statusEl) return;
    if (statusEl.getAttribute('data-fitment-state') === 'universal') return; // never override universal

    var fitmentJson = statusEl.getAttribute('data-product-fitment');
    if (!fitmentJson) return;
    var fitment;
    try { fitment = JSON.parse(fitmentJson); } catch (err) { return; }

    var vehicle = (window.HHymm && window.HHymm.getStoredVehicle) ? window.HHymm.getStoredVehicle() : null;

    statusEl.classList.remove(
      'hh-pdp__fitment--no-vehicle',
      'hh-pdp__fitment--fits',
      'hh-pdp__fitment--no-fit',
      'hh-pdp__fitment--verify'
    );

    if (!vehicle) {
      statusEl.classList.add('hh-pdp__fitment--no-vehicle');
      statusEl.dataset.fitmentState = 'no-vehicle';
      // C2 gating (locked 2026-05-03): when settings.vehicle_banner_enabled
      // is false (current pre-Phase-8 state), the picker section isn't
      // rendered, so the "Pick your vehicle" CTA → #hh-ymm is a dead anchor.
      // Server-side pdp-fitment-status.liquid emits data-banner-enabled to
      // mirror the setting; JS branches its innerHTML write on the same flag.
      // Single flip at Phase 8 cutover activates the CTA across server + JS
      // paths together.
      if (statusEl.dataset.bannerEnabled === 'true') {
        statusEl.innerHTML = '<span><a href="#hh-ymm" class="hh-pdp__fitment-pick">Pick your vehicle</a> to check fit</span>';
      } else {
        statusEl.innerHTML = '<span>See the fitment table below to check fit</span>';
      }
      return;
    }

    var label = vehicleLabel(vehicle);
    var fits = window.HHymm && window.HHymm.matches ? window.HHymm.matches(vehicle, fitment) : false;

    if (fits) {
      statusEl.classList.add('hh-pdp__fitment--fits');
      statusEl.dataset.fitmentState = 'fits';
      statusEl.setAttribute('role', 'status');
      statusEl.innerHTML = ICON_CHECK + ' <span>Fits your ' + escapeHtml(label) + '</span>';
    } else {
      statusEl.classList.add('hh-pdp__fitment--no-fit');
      statusEl.dataset.fitmentState = 'no-fit';
      statusEl.setAttribute('role', 'status');
      statusEl.innerHTML = '<span>Doesn’t fit your ' + escapeHtml(label) + ' — see the fitment table for compatible vehicles</span>';
    }
  }

  function initFitmentStatus() {
    updateFitmentStatus();
    document.addEventListener('hh:vehicle-changed', updateFitmentStatus);
  }

  // ---------------------------------------------------------------
  // Vehicle banner — cascade dropdowns + set/change/clear flows
  //
  // Reads from HHymm (ymm.js) for catalog Y/M/M data. All state mutations
  // funnel through HHymm.setStoredVehicle / clearStoredVehicle (locked
  // funnel pattern in CLAUDE.md). Banner UI listens to hh:vehicle-changed
  // for cross-surface state sync.
  //
  // Banner is opt-in via theme editor (decision 6 deferred-render); this
  // function no-ops when no [data-vehicle-banner] is on the page.
  // ---------------------------------------------------------------
  function initVehicleBanner() {
    var banner = document.querySelector('[data-vehicle-banner]');
    if (!banner) return;

    var form = banner.querySelector('[data-vehicle-banner-form]');
    var yearSelect = banner.querySelector('[data-ymm-year]');
    var makeSelect = banner.querySelector('[data-ymm-make]');
    var modelSelect = banner.querySelector('[data-ymm-model]');
    var submitBtn = banner.querySelector('[data-vehicle-banner-submit]');
    var stored = banner.querySelector('[data-vehicle-banner-stored]');
    var storedLabel = banner.querySelector('[data-vehicle-banner-label]');
    var changeBtn = banner.querySelector('[data-vehicle-banner-change]');
    var clearBtn = banner.querySelector('[data-vehicle-banner-clear]');
    var expandBtn = banner.querySelector('[data-vehicle-banner-expand]');
    if (!form || !yearSelect || !makeSelect || !modelSelect || !submitBtn) return;

    function fillSelect(select, items, currentValue) {
      // Preserve the placeholder option (first child); replace the rest.
      while (select.children.length > 1) select.removeChild(select.lastChild);
      items.forEach(function (val) {
        var opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val;
        if (currentValue && String(val) === String(currentValue)) opt.selected = true;
        select.appendChild(opt);
      });
    }

    function checkSubmitState() {
      var ready = yearSelect.value && makeSelect.value && modelSelect.value;
      submitBtn.disabled = !ready;
      submitBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }

    async function populateYears() {
      var years = await window.HHymm.listYears();
      fillSelect(yearSelect, years);
    }

    async function populateMakes() {
      makeSelect.disabled = !yearSelect.value;
      modelSelect.disabled = true;
      // Reset model + make when year changes
      while (makeSelect.children.length > 1) makeSelect.removeChild(makeSelect.lastChild);
      while (modelSelect.children.length > 1) modelSelect.removeChild(modelSelect.lastChild);
      if (!yearSelect.value) { checkSubmitState(); return; }
      var makes = await window.HHymm.listMakes(yearSelect.value);
      fillSelect(makeSelect, makes);
      checkSubmitState();
    }

    async function populateModels() {
      modelSelect.disabled = !makeSelect.value;
      while (modelSelect.children.length > 1) modelSelect.removeChild(modelSelect.lastChild);
      if (!makeSelect.value) { checkSubmitState(); return; }
      var models = await window.HHymm.listModels(yearSelect.value, makeSelect.value);
      fillSelect(modelSelect, models);
      checkSubmitState();
    }

    function showStoredState(vehicle) {
      banner.classList.remove('hh-vehicle-banner--prominent', 'hh-vehicle-banner--collapsed');
      banner.classList.add('hh-vehicle-banner--stored');
      banner.dataset.state = 'stored';
      if (form) form.hidden = true;
      if (expandBtn) expandBtn.hidden = true;
      if (stored) stored.hidden = false;
      if (storedLabel) {
        storedLabel.textContent = [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ');
      }
    }

    function showFormState() {
      var defaultState = banner.getAttribute('data-state') === 'collapsed' ? 'collapsed' : 'prominent';
      banner.classList.remove('hh-vehicle-banner--stored');
      banner.classList.add('hh-vehicle-banner--' + defaultState);
      banner.dataset.state = defaultState;
      if (stored) stored.hidden = true;
      if (defaultState === 'collapsed') {
        if (expandBtn) expandBtn.hidden = false;
        if (form) form.hidden = true;
      } else {
        if (expandBtn) expandBtn.hidden = true;
        if (form) form.hidden = false;
      }
      // Reset selections
      yearSelect.value = '';
      makeSelect.value = '';
      modelSelect.value = '';
      makeSelect.disabled = true;
      modelSelect.disabled = true;
      checkSubmitState();
    }

    // ── Wire events ──
    yearSelect.addEventListener('change', populateMakes);
    makeSelect.addEventListener('change', populateModels);
    modelSelect.addEventListener('change', checkSubmitState);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn.disabled) return;
      window.HHymm.setStoredVehicle({
        year: yearSelect.value,
        make: makeSelect.value,
        model: modelSelect.value,
      });
      // hh:vehicle-changed fires from HHymm; our listener below handles the UI swap.
    });

    if (expandBtn) {
      expandBtn.addEventListener('click', function () {
        expandBtn.hidden = true;
        if (form) form.hidden = false;
        // Focus first dropdown so the cascade is keyboard-actionable
        yearSelect.focus();
      });
    }

    if (changeBtn) changeBtn.addEventListener('click', showFormState);
    if (clearBtn) clearBtn.addEventListener('click', function () {
      window.HHymm.clearStoredVehicle();
      // Listener below handles the UI swap.
    });

    document.addEventListener('hh:vehicle-changed', function (e) {
      if (e.detail) showStoredState(e.detail);
      else showFormState();
    });

    // ── Sticky offset — runtime-detect sticky-header state ──
    var header = document.querySelector('.hh-header');
    var headerSticky = header && header.getAttribute('data-sticky') === 'true';
    if (headerSticky) {
      var headerHeight = header.offsetHeight;
      banner.style.setProperty('--hh-vehicle-banner-offset', headerHeight + 'px');
    } else {
      banner.style.setProperty('--hh-vehicle-banner-offset', '0');
    }
    banner.setAttribute('data-sticky', 'true');

    // ── Hide during header search focus ──
    var searchEl = document.querySelector('.hh-header__search');
    if (searchEl) {
      searchEl.addEventListener('focusin', function () { banner.dataset.hidden = 'true'; });
      searchEl.addEventListener('focusout', function () { banner.dataset.hidden = 'false'; });
    }

    // ── Initial state from stored vehicle ──
    var initial = window.HHymm.getStoredVehicle();
    if (initial) {
      showStoredState(initial);
    } else {
      // Populate the dropdowns even if collapsed — saves a re-fetch when user expands
      populateYears();
    }
  }

  // ---------------------------------------------------------------
  // PDP "Pick your vehicle" link — scroll to banner OR hide if absent
  //
  // Per locked structural flag B: when banner is on the page (Phase 8+),
  // the link smooth-scrolls to it and focuses the first dropdown. When
  // banner is absent (Phase 1-7 default), the entire fitment-status
  // no-vehicle prompt is hidden so the link never renders a dead-end.
  // ---------------------------------------------------------------
  function initPdpFitmentLink() {
    var banner = document.querySelector('[data-vehicle-banner]');
    var link = document.querySelector('.hh-pdp__fitment-pick');
    var statusEl = document.querySelector('[data-fitment-status][data-fitment-state="no-vehicle"]');

    if (!banner) {
      // Hide the entire no-vehicle fitment-status when banner is absent.
      // Fitment-status with universal_fitment="Yes" is a separate element
      // (data-fitment-state="universal") and stays visible.
      if (statusEl) statusEl.style.display = 'none';
      return;
    }

    if (!link) return;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var firstDropdown = banner.querySelector('select:not([disabled])');
      if (firstDropdown) {
        // Focus after scroll settles
        setTimeout(function () { firstDropdown.focus(); }, 300);
      }
    });
  }

  // ── PDP related products (Phase 2g) ────────────────────────────────
  // Shopify's `recommendations` Liquid object only populates when the
  // ---------------------------------------------------------------
  // PDP-1 — Sticky ATC visibility (mobile-only)
  //
  // Same-form via DOM-proxy click: sticky button does NOT submit a
  // form; it triggers .hh-pdp__atc.click() which submits the canonical
  // {%- form 'product' -%} in pdp-info.liquid. Single source of truth
  // for variant + qty state.
  //
  // Visibility driven by IntersectionObserver on the inline ATC button.
  // When inline ATC is OUT of viewport → sticky shows. When IN viewport
  // → sticky hides. Show-when-out-of-view-only (no scroll-direction
  // logic — banked Gate D: feature-creep concern; revisit post-launch).
  //
  // Mobile-only: CSS @media (max-width: 720px) gates display: block.
  // Desktop has the inline ATC always in view due to right-column
  // sticky buybox layout; sticky bar redundant. JS still runs on
  // desktop but the bar stays display: none, so toggling data-visible
  // is harmless.
  //
  // Reduced-motion: CSS @media (prefers-reduced-motion: reduce) drops
  // the transform transition (snap show/hide) — JS doesn't need to
  // branch on this; CSS handles.
  // ---------------------------------------------------------------
  function initPdpStickyAtc () {
    var stickyEl = document.querySelector('[data-pdp-sticky-atc]');
    var stickyBtn = document.querySelector('[data-pdp-sticky-atc-btn]');
    var inlineAtc = document.querySelector('.hh-pdp__atc');
    if (!stickyEl || !stickyBtn || !inlineAtc) return;

    // DOM-proxy click: sticky button forwards to inline ATC.
    stickyBtn.addEventListener('click', function () {
      // Sync ARIA disabled state from inline ATC (e.g., sold-out).
      if (inlineAtc.disabled || inlineAtc.getAttribute('aria-disabled') === 'true') return;
      inlineAtc.click();
    });

    // Visibility logic — show only when inline ATC is ABOVE viewport
    // (buyer has scrolled past it). Hide when inline is IN viewport OR
    // BELOW viewport (buyer hasn't reached it yet).
    //
    // Defense-in-depth pattern (defensive against IntersectionObserver
    // edge cases):
    //  1. IntersectionObserver — primary trigger for state transitions
    //     during smooth scrolling.
    //  2. Scroll listener — backup trigger for instant scroll cases
    //     (e.g., window.scrollTo(0, 0) jumps from "above viewport" to
    //     "below viewport" without crossing threshold; observer may not
    //     fire because intersection state is false → false).
    //
    // Both paths run the same evaluator: boundingClientRect.bottom < 0
    // means inline is above viewport (scrolled past) → show sticky.
    function evaluateVisibility () {
      var rect = inlineAtc.getBoundingClientRect();
      var scrolledPast = rect.bottom < 0;
      stickyEl.setAttribute('data-visible', String(scrolledPast));
      stickyEl.setAttribute('aria-hidden', String(!scrolledPast));
      // Reflect disabled state on sticky button for sold-out parity.
      var disabled = inlineAtc.disabled || inlineAtc.getAttribute('aria-disabled') === 'true';
      if (disabled) {
        stickyBtn.setAttribute('disabled', '');
        stickyBtn.setAttribute('aria-disabled', 'true');
      } else {
        stickyBtn.removeAttribute('disabled');
        stickyBtn.removeAttribute('aria-disabled');
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(evaluateVisibility, { threshold: [0, 0.1] });
      observer.observe(inlineAtc);
    }

    // rAF-throttled scroll listener — backup trigger.
    var scrollScheduled = false;
    window.addEventListener('scroll', function () {
      if (scrollScheduled) return;
      scrollScheduled = true;
      window.requestAnimationFrame(function () {
        evaluateVisibility();
        scrollScheduled = false;
      });
    }, { passive: true });

    // Initial evaluation (covers page-load state).
    evaluateVisibility();
  }

  // ---------------------------------------------------------------
  // buildVehicleFilterUrl (Phase 2 unified YMM filter, 2026-05-10)
  //
  // Single helper for context-aware vehicle-filter URL construction.
  // Used by:
  //   - initCartVehicleBar modal submit (cart drawer modal)
  //   - initYmmCard default onSubmit (cart-drawer empty YMM, hero YMM)
  //
  // Behavior:
  //   - On a /collections/* page: reload current collection with vehicle
  //     filter params (preserves browse context, surfaces filtered results).
  //   - On any other page: redirect to /collections/all-in-stock-items
  //     with vehicle filter params (catch-all browse surface).
  //
  // URL filter params shape (Shopify Search & Discovery native):
  //   filter.p.m.custom.fitment_years_text — year value
  //   filter.p.m.custom.fitment_makes      — make value
  //   filter.p.m.custom.fitment_models     — model value
  //
  // Same shape as the collection sidebar Cymm picker (line ~1322), so all
  // YMM entry points produce identical URL state. Replaces the prior
  // localStorage-only flow that produced inconsistent client-side dim
  // behavior on the destination page.
  // ---------------------------------------------------------------
  function buildVehicleFilterUrl (vehicle, currentHref) {
    // currentHref optional override — defaults to window.location.href.
    // Test surface: pass an explicit URL to exercise behavior without
    // depending on Shopify storefront page navigation (eliminates flake
    // from rate-limited preview-theme loads). Production callers pass
    // no second arg and use live page state.
    var href = currentHref || window.location.href;
    if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) {
      return href;
    }
    var origin = (typeof window !== 'undefined' && window.location && window.location.origin)
      ? window.location.origin
      : 'https://hubeshub.com';
    var basePath;
    try {
      basePath = new URL(href).pathname;
    } catch (e) {
      basePath = '/';
    }
    var onCollection = basePath.indexOf('/collections/') === 0;
    var url;
    if (onCollection) {
      // On a collection page: preserve other filter/sort params already in
      // URL (e.g. Part Type filter, sort_by). Reload current path with
      // YMM params merged. Drops preview-mode params that Shopify injects
      // when accessing storefront via the preview URL — they're not part
      // of canonical state.
      url = new URL(href);
      ['_ab', '_fd', '_sc'].forEach(function (k) { url.searchParams.delete(k); });
    } else {
      // Off-collection (homepage / PDP / search / etc.): fresh URL on the
      // catch-all all-in-stock-items collection.
      url = new URL('/collections/all-in-stock-items', origin);
    }
    url.searchParams.set('filter.p.m.custom.fitment_years_text', String(vehicle.year));
    url.searchParams.set('filter.p.m.custom.fitment_makes', String(vehicle.make));
    url.searchParams.set('filter.p.m.custom.fitment_models', String(vehicle.model));
    url.searchParams.delete('page');
    return url.toString();
  }
  // window.HHbuildVehicleFilterUrl — TEST-ONLY exposure.
  // Functional tests in tests/functional/ymm-unified-filter.test.js exercise
  // this helper via page.evaluate(), which can only see globals. THEME CODE
  // (other functions in this file, Liquid render paths) MUST NOT call the
  // global-scoped name. Use the lexically-scoped buildVehicleFilterUrl
  // identifier directly within this IIFE. Future-resistant: keeps the
  // public API surface narrow + prevents accidental coupling to global.
  if (typeof window !== 'undefined') {
    window.HHbuildVehicleFilterUrl = buildVehicleFilterUrl;
  }

  // ---------------------------------------------------------------
  // CART-1 — Vehicle context bar + per-line fitment warning + modal
  //
  // Vehicle bar (cart-vehicle-bar snippet) renders only when
  // HHymm.getStoredVehicle() resolves. Listens to hh:vehicle-changed
  // for re-render on vehicle updates (modal submit, future Phase 8
  // banner submit, clear).
  //
  // Per-line warning: cart-drawer-line-item emits data-line-fitment
  // (JSON ranges) + data-line-universal flags. JS reads, calls
  // HHymm.matches per line, toggles .hh-cart-line--warn on lines that
  // don't match. Universal-fitment lines skip the warn pass. Direct
  // reuse of Phase 3d card-dim pattern; no adaptation.
  //
  // Modal ([Change] flow): cart-scoped one-off (Gate A locked
  // 2026-05-03 — build for current consumers; abstract on second use).
  // YMM cascading dropdowns via HHymm.listYears / listMakes / listModels.
  // Submit calls HHymm.setStoredVehicle which auto-dispatches
  // hh:vehicle-changed; bar listener handles re-render.
  // ---------------------------------------------------------------
  function initCartVehicleBar () {
    var bars = document.querySelectorAll('[data-cart-vehicle-bar]');
    var modal = document.querySelector('[data-cart-vehicle-modal]');
    if (bars.length === 0 && !modal) return; // not on a cart surface

    function vehicleLabelFromObj (v) {
      if (!v) return '';
      return [v.year, v.make, v.model].filter(Boolean).join(' ');
    }

    function renderBars (vehicle) {
      var label = vehicleLabelFromObj(vehicle);
      bars.forEach(function (bar) {
        var nameEl = bar.querySelector('[data-cart-vehicle-name]');
        if (vehicle && label) {
          if (nameEl) nameEl.textContent = label;
          bar.dataset.vehicle = label;
          bar.removeAttribute('hidden');
        } else {
          if (nameEl) nameEl.textContent = '';
          bar.dataset.vehicle = '';
          bar.setAttribute('hidden', '');
        }
      });
    }

    function evaluateLines (vehicle) {
      var lines = document.querySelectorAll('.hh-cart-line');
      lines.forEach(function (line) {
        // Universal fitment skip — line fits any vehicle, no warn.
        if (line.dataset.lineUniversal === 'true') {
          line.classList.remove('hh-cart-line--warn');
          return;
        }
        var fitmentJson = line.getAttribute('data-line-fitment');
        if (!fitmentJson) {
          // No fitment data — no basis for warn; skip (don't mark warn,
          // don't mark clear; preserves existing state if any).
          line.classList.remove('hh-cart-line--warn');
          return;
        }
        // No vehicle stored → clear all warnings (buyer is browsing
        // without context; warn is irrelevant).
        if (!vehicle) {
          line.classList.remove('hh-cart-line--warn');
          return;
        }
        var fitment;
        try { fitment = JSON.parse(fitmentJson); } catch (err) { return; }
        var fits = window.HHymm && window.HHymm.matches ? window.HHymm.matches(vehicle, fitment) : false;
        if (fits) {
          line.classList.remove('hh-cart-line--warn');
        } else {
          line.classList.add('hh-cart-line--warn');
        }
      });
    }

    function refreshFromStorage () {
      var vehicle = (window.HHymm && window.HHymm.getStoredVehicle) ? window.HHymm.getStoredVehicle() : null;
      renderBars(vehicle);
      evaluateLines(vehicle);
    }

    // [Change] click → open modal
    document.addEventListener('click', function (e) {
      var changeBtn = e.target.closest('[data-cart-vehicle-change]');
      if (changeBtn && modal) {
        openModal();
        return;
      }
      var clearBtn = e.target.closest('[data-cart-vehicle-clear]');
      if (clearBtn) {
        // Clear stored vehicle → fires hh:vehicle-changed → bar re-renders hidden
        if (window.HHymm && typeof window.HHymm.clearStoredVehicle === 'function') {
          window.HHymm.clearStoredVehicle();
        }
        return;
      }
      var closeBtn = e.target.closest('[data-cart-vehicle-modal-close]');
      if (closeBtn && modal) {
        closeModal();
      }
    });

    // Modal lifecycle
    var lastFocusedEl = null;
    function openModal () {
      if (!modal) return;
      lastFocusedEl = document.activeElement;
      modal.dataset.open = 'true';
      modal.setAttribute('aria-hidden', 'false');
      // Populate Year if not already populated
      ensureYearsPopulated();
      // Focus the first interactable
      var firstSelect = modal.querySelector('[data-cart-vehicle-year]');
      if (firstSelect) firstSelect.focus({ preventScroll: true });
    }
    function closeModal () {
      if (!modal) return;
      modal.dataset.open = 'false';
      modal.setAttribute('aria-hidden', 'true');
      if (lastFocusedEl && lastFocusedEl.focus) lastFocusedEl.focus({ preventScroll: true });
    }

    // Escape closes modal
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.dataset.open === 'true') closeModal();
    });

    // YMM cascading dropdowns
    var yearsPopulated = false;
    async function ensureYearsPopulated () {
      if (yearsPopulated || !modal || !window.HHymm || !window.HHymm.listYears) return;
      var sel = modal.querySelector('[data-cart-vehicle-year]');
      if (!sel) return;
      try {
        var years = await window.HHymm.listYears();
        years.forEach(function (y) {
          var opt = document.createElement('option');
          opt.value = String(y);
          opt.textContent = String(y);
          sel.appendChild(opt);
        });
        yearsPopulated = true;
      } catch (err) { /* swallow; no-op */ }
    }

    if (modal) {
      var yearSel = modal.querySelector('[data-cart-vehicle-year]');
      var makeSel = modal.querySelector('[data-cart-vehicle-make]');
      var modelSel = modal.querySelector('[data-cart-vehicle-model]');
      var submitBtn = modal.querySelector('[data-cart-vehicle-submit]');
      var form = modal.querySelector('[data-cart-vehicle-form]');

      function resetSelect (sel, placeholder) {
        if (!sel) return;
        sel.innerHTML = '';
        var opt = document.createElement('option');
        opt.value = '';
        opt.textContent = placeholder;
        sel.appendChild(opt);
        sel.disabled = true;
      }
      function populateSelect (sel, items) {
        if (!sel) return;
        items.forEach(function (item) {
          var opt = document.createElement('option');
          opt.value = String(item);
          opt.textContent = String(item);
          sel.appendChild(opt);
        });
        sel.disabled = false;
      }
      function updateSubmitState () {
        if (!submitBtn) return;
        var enabled = yearSel && makeSel && modelSel && yearSel.value && makeSel.value && modelSel.value;
        submitBtn.disabled = !enabled;
      }

      if (yearSel) yearSel.addEventListener('change', async function () {
        resetSelect(makeSel, 'Make');
        resetSelect(modelSel, 'Model');
        updateSubmitState();
        if (!yearSel.value) return;
        try {
          var makes = await window.HHymm.listMakes(parseInt(yearSel.value, 10));
          populateSelect(makeSel, makes);
        } catch (err) { /* swallow */ }
      });
      if (makeSel) makeSel.addEventListener('change', async function () {
        resetSelect(modelSel, 'Model');
        updateSubmitState();
        if (!makeSel.value) return;
        try {
          var models = await window.HHymm.listModels(parseInt(yearSel.value, 10), makeSel.value);
          populateSelect(modelSel, models);
        } catch (err) { /* swallow */ }
      });
      if (modelSel) modelSel.addEventListener('change', updateSubmitState);

      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!yearSel || !makeSel || !modelSel) return;
        var vehicle = { year: parseInt(yearSel.value, 10), make: makeSel.value, model: modelSel.value };
        if (!vehicle.year || !vehicle.make || !vehicle.model) return;
        if (window.HHymm && window.HHymm.setStoredVehicle) {
          window.HHymm.setStoredVehicle(vehicle); // auto-dispatches hh:vehicle-changed
        }
        closeModal();
        // BEHAVIOR CHANGE 2026-05-10 (Phase 2 unified YMM filter):
        // Modal previously closed without redirect — buyer stayed on
        // current page with stored vehicle in localStorage; downstream
        // surfaces did client-side dim filtering inconsistently. Per Jodi
        // UAT feedback (greyed-grid surfaces vs clean make-collection
        // empty-state), all YMM submit entry points now route through
        // buildVehicleFilterUrl, producing the same Shopify-native
        // server-side filter URL pattern + filter-result-zero empty-state
        // when no matches. Modal submit redirects to current collection
        // (preserving browse context) or /collections/all-in-stock-items
        // (catch-all from non-collection pages).
        window.location.href = buildVehicleFilterUrl(vehicle);
      });
    }

    // Subscribe to vehicle changes (modal submit, future banner submit, clear)
    document.addEventListener('hh:vehicle-changed', refreshFromStorage);

    // Initial state
    refreshFromStorage();
  }

  // ---------------------------------------------------------------
  // initYmmCard — generic cascading-dropdown YMM finder.
  //
  // Refactored from initCartEmptyYmm at H0 of Phase 4 v1 build (2026-05-03)
  // when Hero became the second consumer of this pattern. Markup extracted
  // to snippets/ymm-card.liquid in the same H0 commit.
  //
  // Lazy-populates years on first focus (avoids fetching on every page load
  // when buyer never engages). Cascading dropdowns: year → make → model.
  // On submit, sets stored vehicle via HHymm.setStoredVehicle and redirects
  // (default: /collections/all-in-stock-items per Composition A-revised
  // routing + Pass 1 D5 lock). Custom onSubmit callback overrides the
  // default for surfaces with surface-specific behavior.
  //
  // Selectors derived from opts.prefix:
  //   form          — [data-{prefix}-ymm]
  //   year select   — [data-{prefix}-year]
  //   make select   — [data-{prefix}-make]
  //   model select  — [data-{prefix}-model]
  //   submit button — [data-{prefix}-ymm-submit]
  //
  // Both current consumers (cart-empty + Hero) use the default onSubmit
  // behavior; the callback hook is present as a divergence-readiness
  // affordance (per Steve's H0 sign-off) but neither caller needs it today.
  // ---------------------------------------------------------------
  function initYmmCard (opts) {
    opts = opts || {};
    var prefix = opts.prefix;
    if (!prefix) return;
    var onSubmit = opts.onSubmit || function (vehicle) {
      if (window.HHymm && window.HHymm.setStoredVehicle) {
        window.HHymm.setStoredVehicle(vehicle);
      }
      // Phase 2 unified YMM filter (2026-05-10): redirect with URL filter
      // params (Shopify-native server-side filtering). Replaces prior
      // localStorage-only redirect that produced inconsistent client-side
      // dim behavior. Helper handles context-aware destination
      // (current collection vs /collections/all-in-stock-items).
      window.location.href = buildVehicleFilterUrl(vehicle);
    };

    var forms = document.querySelectorAll('[data-' + prefix + '-ymm]');
    if (forms.length === 0) return;

    forms.forEach(function (form) {
      var yearSel = form.querySelector('[data-' + prefix + '-year]');
      var makeSel = form.querySelector('[data-' + prefix + '-make]');
      var modelSel = form.querySelector('[data-' + prefix + '-model]');
      var submitBtn = form.querySelector('[data-' + prefix + '-ymm-submit]');
      if (!yearSel || !makeSel || !modelSel) return;

      // Lazy-populate years on first focus (extracted to ensureYearsPopulated
      // helper so pre-population path can reuse the year-fetch logic without
      // duplicating it).
      var yearsPopulated = false;
      async function ensureYearsPopulated () {
        if (yearsPopulated || !window.HHymm || !window.HHymm.listYears) return;
        try {
          var years = await window.HHymm.listYears();
          years.forEach(function (y) {
            var opt = document.createElement('option');
            opt.value = String(y);
            opt.textContent = String(y);
            yearSel.appendChild(opt);
          });
          yearsPopulated = true;
        } catch (err) { /* swallow */ }
      }
      yearSel.addEventListener('focus', ensureYearsPopulated);

      function resetSelect (sel, placeholder) {
        sel.innerHTML = '';
        var opt = document.createElement('option');
        opt.value = '';
        opt.textContent = placeholder;
        sel.appendChild(opt);
        sel.disabled = true;
      }
      function populateSelect (sel, items) {
        items.forEach(function (item) {
          var opt = document.createElement('option');
          opt.value = String(item);
          opt.textContent = String(item);
          sel.appendChild(opt);
        });
        sel.disabled = false;
      }
      function updateSubmitState () {
        if (!submitBtn) return;
        submitBtn.disabled = !(yearSel.value && makeSel.value && modelSel.value);
      }

      yearSel.addEventListener('change', async function () {
        resetSelect(makeSel, 'Make');
        resetSelect(modelSel, 'Model');
        updateSubmitState();
        if (!yearSel.value || !window.HHymm || !window.HHymm.listMakes) return;
        try {
          var makes = await window.HHymm.listMakes(parseInt(yearSel.value, 10));
          populateSelect(makeSel, makes);
        } catch (err) { /* swallow */ }
      });
      makeSel.addEventListener('change', async function () {
        resetSelect(modelSel, 'Model');
        updateSubmitState();
        if (!makeSel.value || !window.HHymm || !window.HHymm.listModels) return;
        try {
          var models = await window.HHymm.listModels(parseInt(yearSel.value, 10), makeSel.value);
          populateSelect(modelSel, models);
        } catch (err) { /* swallow */ }
      });
      modelSel.addEventListener('change', updateSubmitState);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vehicle = { year: parseInt(yearSel.value, 10), make: makeSel.value, model: modelSel.value };
        if (!vehicle.year || !vehicle.make || !vehicle.model) return;
        onSubmit(vehicle);
      });

      // Pre-population path (SD-3-4 universal application — H3 lock 2026-05-03):
      // if a stored vehicle exists, eagerly populate cascading dropdowns and
      // select stored year/make/model. Benefits return visitors who land on
      // any surface consuming the shared snippet (Hero + cart-empty today;
      // future surfaces auto-inherit). Falls through silently to existing
      // lazy-populate-on-focus behavior on any failure (HHymm not yet ready,
      // empty fitment data, malformed stored vehicle, async error).
      //
      // Pattern 3 (defensive synchronous reads): try/catch fall-through;
      // existing lazy-populate-on-focus behavior is the silent fallback path.
      (async function prePopulateFromStoredVehicle () {
        try {
          if (!window.HHymm || !window.HHymm.getStoredVehicle) return;
          var stored = window.HHymm.getStoredVehicle();
          if (!stored || !stored.year || !stored.make || !stored.model) return;

          await ensureYearsPopulated();
          if (!yearsPopulated) return;
          yearSel.value = String(stored.year);

          var makes = await window.HHymm.listMakes(stored.year);
          if (!makes || makes.length === 0) return;
          populateSelect(makeSel, makes);
          makeSel.value = stored.make;

          var models = await window.HHymm.listModels(stored.year, stored.make);
          if (!models || models.length === 0) return;
          populateSelect(modelSel, models);
          modelSel.value = stored.model;

          updateSubmitState();
        } catch (err) { /* swallow; lazy-populate fallback remains for buyer */ }
      })();
    });
  }

  // ---------------------------------------------------------------
  // section is requested via Section Rendering API. On first paint the
  // section renders empty; this fetch populates it post-paint.
  // Below-the-fold, lazy — does not impact LCP.
  function initPdpRelated () {
    var el = document.querySelector('[data-pdp-related]');
    if (!el) return;
    var url = el.dataset.fetchUrl;
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-pdp-related]');
        if (fresh) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* silent — empty section is acceptable */ });
  }

  // Collection "Show 24 more" — SRA fetch + append + pushState + nav replace.
  // Mirrors the SRA pattern from 2g initPdpRelated. Click-triggered + append-
  // mode variant of the locked architecture (2g was load-triggered + replace-
  // mode for the empty PDP-related wrapper).
  //
  // Server-side button-hide pattern (3b-iv-3 §C): the new pagination nav from
  // the SRA response either contains a .hh-collection__load-more anchor (more
  // pages exist) or doesn't (last page). JS replaces the entire pagination nav
  // with the new one — button-hide is a side-effect of the server-side render.
  //
  // Sort + pagination URL coordination: paginate.next.url already encodes the
  // current sort_by, so data-sra-url and data-next-page-url both preserve sort
  // through every load-more cycle automatically.
  //
  // Event delegation: the load-more anchor gets replaced after each click
  // (along with the rest of the pagination nav), so we listen on document
  // and match via .closest() rather than binding directly to the element.
  function initLoadMore () {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.hh-collection__load-more');
      if (!btn) return;
      // honor open-in-new-tab modifiers
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;
      var sraUrl = btn.dataset.sraUrl;
      var nextPageUrl = btn.dataset.nextPageUrl;
      if (!sraUrl || !nextPageUrl) return;
      ev.preventDefault();
      btn.setAttribute('aria-busy', 'true');
      fetch(sraUrl)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) {
            btn.removeAttribute('aria-busy');
            return;
          }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          // Append new cards to current grid
          var newGrid = doc.querySelector('.hh-collection__grid');
          var currentGrid = document.querySelector('.hh-collection__grid');
          if (newGrid && currentGrid) {
            while (newGrid.firstElementChild) {
              currentGrid.appendChild(newGrid.firstElementChild);
            }
          }
          // Replace pagination nav with the new one (auto button-hide on last page)
          var newNav = doc.querySelector('nav.hh-collection__pagination');
          var currentNav = document.querySelector('nav.hh-collection__pagination');
          if (newNav && currentNav) {
            currentNav.replaceWith(newNav);
          } else if (currentNav && !newNav) {
            // Edge case: shouldn't happen given paginate.pages > 1 guard, but be safe
            currentNav.remove();
          }
          // Advance URL — buyer can refresh / share-link to ?page=N
          window.history.pushState({}, '', nextPageUrl);
        })
        .catch(function () {
          // Silent — buyer can fall back to clicking again or full-reload via href
          btn.removeAttribute('aria-busy');
        });
    });
  }

  // Collection filters — auto-submit on checkbox change (DESKTOP ONLY).
  // Form has method="get" + native checkbox semantics. Submitting the form
  // rebuilds the URL from currently-checked boxes; unchecked boxes are
  // correctly OMITTED. We do NOT build URLs by hand — see the "DO NOT switch
  // to JS-driven URL composition" comment in collection-filters.liquid.
  // No-JS fallback: form's <button type="submit"> visible when .no-js
  // remains on <html> (i.e., JS disabled or failed to run).
  //
  // Mobile (<1024px): batch + Apply pattern (3c-5 §3-A). Checkbox ticks
  // sit in form state until the visible Apply button submits. matchMedia
  // is read at change-event time, NOT cached at page load: buyers who
  // resize browser mid-session experience new behavior on next interaction
  // (responsive philosophy). Future maintainers: do NOT cache this — that
  // would break the responsive contract.
  function initCollectionFilters () {
    var form = document.querySelector('form.hh-filters__form');
    if (!form) return;
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT' || t.type !== 'checkbox') return;
      var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      if (!isDesktop) return;  // mobile: batch+apply, don't auto-submit
      form.submit();
    });
  }

  // Cymm — Collection-sidebar YMM picker (Phase 3 / Phase 9c-D, 2026-05-08).
  //
  // Atom spec: docs/design-source/2026-05-08-ymm-picker/Design - YMM Sidebar Picker.html
  // CSS: assets/coll-ymm.css
  // Liquid: snippets/collection-ymm-picker.liquid
  //
  // Replaces the flat Make / Model / Year facet checkboxes in the rail
  // with a cascading-dropdown picker pinned at the top of the sidebar.
  // Same URL params that the flat facets wrote (filter.p.m.custom.
  // fitment_makes / fitment_models / fitment_years_text) — only the UI
  // is replaced; Search & Discovery filtering is unchanged.
  //
  // Five render states (per spec):
  //   01 Empty       — Year active; Make/Model disabled; Apply+Clear disabled
  //   02 Cascade 1/3 — Year picked; Make active; Apply disabled, Clear enabled
  //   03 Cascade 2/3 — Year+Make picked; Model active; Apply still disabled
  //   04 Ready       — All three picked; Apply electric blue
  //   05 Locked      — Compact card; Edit / Clear vehicle actions
  //
  // Three entry vectors:
  //   - User lands on collection with no YMM URL params + no stored
  //     vehicle → render empty state
  //   - User lands with YMM URL params (server-side detection in the
  //     liquid) → render locked state directly
  //   - User lands with no URL params but stored vehicle exists in
  //     HHymm.getStoredVehicle() → JS swaps to locked state on mount
  //     (next click Apply re-applies URL params for current path)
  //
  // Edit transition: locked → cascade. Pre-fills the three selects with
  // the current vehicle. Visual differentiation handled by CSS swap of
  // .is-locked → cascade chrome (blue-tint, same as empty).
  //
  // Clear from locked: clears HHymm storage + strips YMM params from
  // current URL + reloads.
  function initCollectionYmmPicker () {
    var root = document.querySelector('[data-hh-cymm]');
    if (!root) return;
    if (!window.HHymm) return;

    var emptyEl = root.querySelector('[data-hh-cymm-empty]');
    var lockedEl = root.querySelector('[data-hh-cymm-locked]');
    var lockedVehEl = root.querySelector('[data-hh-cymm-locked-veh]');
    var yearSel = root.querySelector('[data-hh-cymm-year-select]');
    var makeSel = root.querySelector('[data-hh-cymm-make-select]');
    var modelSel = root.querySelector('[data-hh-cymm-model-select]');
    var applyBtn = root.querySelector('[data-hh-cymm-apply]');
    var clearCascadeBtn = root.querySelector('[data-hh-cymm-clear-cascade]');
    var editBtn = root.querySelector('[data-hh-cymm-edit]');
    var clearVehBtn = root.querySelector('[data-hh-cymm-clear-vehicle]');

    // ─── Collection-scoped cascade (Phase 3 follow-up, 2026-05-08) ──────
    // The picker calls HHymm.listYears/listMakes/listModels which load from
    // the GLOBAL fitment graph. On a make-specific or part-type-specific
    // collection (e.g. /collections/chrysler), the global list contains
    // makes that aren't in this collection — selecting them yields zero
    // results.
    //
    // Server-side, the liquid serialises collection.filters → fitment_*
    // values into JSON arrays on data-hh-cymm-scope-*. We intersect each
    // global list with the collection scope. If scope is empty (collection
    // has no fitment data — extreme edge case), fall back to the global
    // list to avoid catastrophic empty dropdowns.
    function parseScope (key) {
      try {
        var raw = root.dataset[key];
        if (!raw) return [];
        var arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.map(String) : [];
      } catch (e) { return []; }
    }
    var scopeYears = parseScope('hhCymmScopeYears');
    var scopeMakes = parseScope('hhCymmScopeMakes');
    var scopeModels = parseScope('hhCymmScopeModels');

    function intersectScope (globalList, scope) {
      // Fallback: empty scope → return global (defense against catalog gaps)
      if (!scope || scope.length === 0) return globalList;
      var scopeSet = new Set(scope);
      return globalList.filter(function (it) { return scopeSet.has(String(it)); });
    }

    // ─── State helpers ────────────────────────────────────────────
    function showEmpty () {
      root.classList.remove('is-locked');
      lockedEl.hidden = true;
      emptyEl.hidden = false;
    }
    function showLocked (year, make, model) {
      root.classList.add('is-locked');
      emptyEl.hidden = true;
      lockedEl.hidden = false;
      lockedVehEl.textContent = year + ' ' + make + ' ' + model;
    }
    function resetSelect (sel, placeholder) {
      sel.innerHTML = '';
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = placeholder;
      sel.appendChild(opt);
      sel.disabled = true;
    }
    function populateSelect (sel, items, placeholder) {
      sel.innerHTML = '';
      var blank = document.createElement('option');
      blank.value = '';
      blank.textContent = placeholder;
      sel.appendChild(blank);
      items.forEach(function (it) {
        var opt = document.createElement('option');
        opt.value = String(it);
        opt.textContent = String(it);
        sel.appendChild(opt);
      });
      sel.disabled = false;
    }
    function updateApplyState () {
      var ready = !!(yearSel.value && makeSel.value && modelSel.value);
      applyBtn.disabled = !ready;
      applyBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }
    function updateClearState () {
      clearCascadeBtn.disabled = !(yearSel.value || makeSel.value || modelSel.value);
    }

    // ─── Cascade wiring ──────────────────────────────────────────
    var yearsPopulated = false;
    async function ensureYearsPopulated () {
      if (yearsPopulated) return;
      try {
        var years = await window.HHymm.listYears();
        var scoped = intersectScope(years, scopeYears);
        var blank = yearSel.querySelector('option[value=""]');
        scoped.forEach(function (y) {
          var opt = document.createElement('option');
          opt.value = String(y);
          opt.textContent = String(y);
          yearSel.appendChild(opt);
        });
        if (blank) blank.textContent = 'Select year';
        yearsPopulated = true;
      } catch (err) { /* swallow */ }
    }
    yearSel.addEventListener('focus', ensureYearsPopulated);

    yearSel.addEventListener('change', async function () {
      resetSelect(makeSel, 'Pick year first');
      resetSelect(modelSel, 'Pick make first');
      if (yearSel.value) {
        try {
          var makes = await window.HHymm.listMakes(parseInt(yearSel.value, 10));
          var scoped = intersectScope(makes, scopeMakes);
          populateSelect(makeSel, scoped, 'Select make');
        } catch (err) { /* swallow */ }
      }
      updateApplyState();
      updateClearState();
    });
    makeSel.addEventListener('change', async function () {
      resetSelect(modelSel, 'Pick make first');
      if (makeSel.value) {
        try {
          var models = await window.HHymm.listModels(parseInt(yearSel.value, 10), makeSel.value);
          var scoped = intersectScope(models, scopeModels);
          populateSelect(modelSel, scoped, 'Select model');
        } catch (err) { /* swallow */ }
      }
      updateApplyState();
      updateClearState();
    });
    modelSel.addEventListener('change', function () {
      updateApplyState();
      updateClearState();
    });

    // ─── Apply ───────────────────────────────────────────────────
    applyBtn.addEventListener('click', function () {
      if (applyBtn.disabled) return;
      var year = parseInt(yearSel.value, 10);
      var make = makeSel.value;
      var model = modelSel.value;
      if (!year || !make || !model) return;
      var vehicle = { year: year, make: make, model: model };
      try {
        window.HHymm.setStoredVehicle(vehicle);
      } catch (err) { /* swallow */ }
      // Phase 2 unified YMM filter (2026-05-10): use shared helper for URL
      // construction. On collection pages this preserves current filter
      // state + drops Shopify preview-mode params; off-collection paths
      // route to /collections/all-in-stock-items. Replaces inline URL build
      // that diverged on preview-param handling.
      window.location.assign(buildVehicleFilterUrl(vehicle));
    });

    // ─── Clear (cascade in-progress) ─────────────────────────────
    clearCascadeBtn.addEventListener('click', function () {
      yearSel.value = '';
      resetSelect(makeSel, 'Pick year first');
      resetSelect(modelSel, 'Pick make first');
      updateApplyState();
      updateClearState();
    });

    // ─── Edit (locked → cascade with values pre-filled) ──────────
    editBtn.addEventListener('click', async function () {
      var year = root.dataset.hhCymmYear;
      var make = root.dataset.hhCymmMake;
      var model = root.dataset.hhCymmModel;
      // Show cascade
      showEmpty();
      // Populate selects in order, pre-selecting each. Awaits keep cascade
      // dependencies correct: makes can't load until year is set.
      await ensureYearsPopulated();
      if (year) yearSel.value = year;
      if (year && make) {
        try {
          var makes = await window.HHymm.listMakes(parseInt(year, 10));
          var scopedMakes = intersectScope(makes, scopeMakes);
          populateSelect(makeSel, scopedMakes, 'Select make');
          makeSel.value = make;
        } catch (err) { /* swallow */ }
      }
      if (year && make && model) {
        try {
          var models = await window.HHymm.listModels(parseInt(year, 10), make);
          var scopedModels = intersectScope(models, scopeModels);
          populateSelect(modelSel, scopedModels, 'Select model');
          modelSel.value = model;
        } catch (err) { /* swallow */ }
      }
      updateApplyState();
      updateClearState();
      yearSel.focus();
    });

    // ─── Clear vehicle (locked) ──────────────────────────────────
    clearVehBtn.addEventListener('click', function () {
      try {
        window.HHymm.clearStoredVehicle();
      } catch (err) { /* swallow */ }
      // Strip YMM params + reload.
      var url = new URL(window.location.href);
      url.searchParams.delete('filter.p.m.custom.fitment_years_text');
      url.searchParams.delete('filter.p.m.custom.fitment_makes');
      url.searchParams.delete('filter.p.m.custom.fitment_models');
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    // ─── Hydrate-on-mount: storedVehicle without URL params ──────
    // If the picker rendered empty (no URL params) but HHymm has a stored
    // vehicle (e.g. user came from homepage with vehicle set), swap to
    // locked state. Apply on Edit re-applies URL params for current path.
    (function hydrateFromStored () {
      if (root.classList.contains('is-locked')) return; // server-rendered locked
      try {
        var stored = window.HHymm.getStoredVehicle && window.HHymm.getStoredVehicle();
        if (!stored || !stored.year || !stored.make || !stored.model) return;
        root.dataset.hhCymmYear = String(stored.year);
        root.dataset.hhCymmMake = stored.make;
        root.dataset.hhCymmModel = stored.model;
        showLocked(stored.year, stored.make, stored.model);
      } catch (err) { /* swallow */ }
    })();
  }

  // Filter show-more (Phase 2 Commit 3, 2026-05-08).
  // Non-YMM accordion groups (Part Type) cap visible options at 8; surplus
  // values render with class .hh-filters__option-row--overflow + the
  // `[data-overflow="true"]` attribute, hidden by CSS until JS adds
  // `.hh-filters__group--expanded` to the parent <details>. Click toggles
  // expanded state, updates aria-expanded + button label.
  //
  // Selector: [data-hh-filter-show-more] inside any .hh-filters__group.
  // No-JS fallback: button is rendered but inert; surplus values stay
  // hidden. Acceptable — JS-disabled buyers see the top 8 most common
  // values, which covers the vast majority of buyer searches by frequency.
  function initFilterShowMore () {
    var buttons = document.querySelectorAll('[data-hh-filter-show-more]');
    if (!buttons.length) return;
    Array.prototype.forEach.call(buttons, function (btn) {
      var group = btn.closest('.hh-filters__group');
      var hidden = btn.getAttribute('data-hidden-count') || '';
      btn.addEventListener('click', function () {
        var expanded = group.classList.toggle('hh-filters__group--expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? 'Show less' : 'Show ' + hidden + ' more';
      });
    });
  }

  // Filter drawer (3c-5) — mobile/tablet only.
  // Slide-from-right drawer triggered by [data-hh-filter-trigger]. Uses
  // position-fixed body scroll lock with scroll-position restoration
  // (canonical mobile-web pattern; avoids known overflow:hidden bugs on
  // iOS Safari). Focus trap inside drawer when open. ESC + scrim-click +
  // close-button + Apply-submit all close the drawer. Trigger receives
  // focus return on close.
  //
  // Drawer is the same <aside class="hh-filters"> that renders as a
  // static sidebar at ≥1024px. CSS @media handles the surface duality;
  // JS only manages the drawer-open/closed state attribute.
  //
  // No-JS fallback: trigger button is dead (CSS shows it but click does
  // nothing). Acceptable — JS-disabled mobile buyers see the same
  // sidebar-hidden layout as before 3c-5 (no regression vs 3c-2/3/4
  // mobile state). Don't over-engineer.
  function initCollectionFilterDrawer () {
    var trigger = document.querySelector('[data-hh-filter-trigger]');
    var aside = document.getElementById('hh-filter-drawer');
    var scrim = document.querySelector('[data-hh-filter-drawer-scrim]');
    var closeBtn = aside && aside.querySelector('[data-hh-filter-drawer-close]');
    if (!trigger || !aside) return;

    var savedScrollY = 0;

    function openDrawer () {
      // Save scroll position, lock body via position:fixed (iOS Safari-safe).
      savedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      aside.setAttribute('data-open', 'true');
      if (scrim) {
        scrim.removeAttribute('hidden');
        scrim.setAttribute('data-open', 'true');
      }
      trigger.setAttribute('aria-expanded', 'true');
      // preventScroll: true required — default focus() behavior scrolls focused
      // element into view even when already visible, which conflicts with the
      // position-fixed scroll-lock restoration pattern. Without preventScroll,
      // window.scrollTo() in the close path is silently overridden by the
      // trigger.focus() side effect. Discovered at 3.5-2 audit; applies to all
      // drawer focus calls during open/close transitions.
      var firstFocusable = aside.querySelector('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus({ preventScroll: true });
    }

    function closeDrawer () {
      // Restore body + scroll position, return focus to trigger.
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, savedScrollY);
      aside.setAttribute('data-open', 'false');
      if (scrim) {
        scrim.setAttribute('data-open', 'false');
        // Re-hide for the transition end; keep removable from a11y tree
        setTimeout(function () {
          if (scrim.getAttribute('data-open') === 'false') scrim.setAttribute('hidden', '');
        }, 250);
      }
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({ preventScroll: true });
    }

    trigger.addEventListener('click', openDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && aside.getAttribute('data-open') === 'true') {
        e.preventDefault();
        closeDrawer();
      }
    });

    // Focus trap inside drawer when open. Tab cycles forward; Shift+Tab cycles back.
    aside.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (aside.getAttribute('data-open') !== 'true') return;
      var focusables = aside.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus({ preventScroll: true });
      }
    });
  }

  // Collection sort dropdown — auto-submit on change.
  // Featured (empty value) → strip sort_by + page from URL (clean URL).
  // Non-empty value → set sort_by, strip page (sort change resets pagination).
  // No JS fallback: native form submit works (Shopify treats empty sort_by as default;
  // page param naturally drops because the form has no hidden page input).
  function initCollectionSort () {
    var form = document.querySelector('form.hh-collection__sort[data-hh-sort]');
    if (!form) return;
    var select = form.querySelector('select[name="sort_by"]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(form.action, window.location.origin);
      var value = select.value;
      if (value) {
        url.searchParams.set('sort_by', value);
      } else {
        url.searchParams.delete('sort_by');
      }
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // ---------------------------------------------------------------
  // Collection vehicle banner (replaces Phase 3d card-dim, 2026-05-10)
  //
  // Surfaces stored vehicle on collection pages without URL filter
  // applied. Replaces the prior auto-dim-non-matching-cards behavior
  // with explicit Apply / Change / Clear affordances. See lesson #23
  // in docs/category-architecture-best-practices.md.
  //
  // Visibility rules:
  //   1. No stored vehicle → hidden (no banner ever)
  //   2. URL has any filter.p.m.custom.fitment_* param → hidden
  //      (filter is already active; banner would be redundant)
  //   3. Otherwise → visible with vehicle name + 3 actions
  //
  // Action wiring:
  //   Apply  → window.location.href = buildVehicleFilterUrl(vehicle, currentHref)
  //            (preserves current collection — does NOT redirect to
  //            /collections/all-in-stock-items per the second-arg contract)
  //   Change → opens existing cart-vehicle-modal (reuse, don't duplicate)
  //   Clear  → HHymm.clearStoredVehicle() → fires hh:vehicle-changed →
  //            updateCollectionVehicleBanner re-renders to hidden state
  //
  // Reader of hh:vehicle-changed (per CLAUDE.md "YMM event flow funnel"
  // — writers funnel through HHymm.setStored / clearStoredVehicle,
  // readers listen to the dispatched event). Re-attach: full-page nav
  // on filter/sort/pagination triggers fresh DOMContentLoaded → init
  // runs again. No SRA-style re-attach needed (collection grid uses
  // native paginate, not SRA fetch).
  // ---------------------------------------------------------------
  function urlHasFitmentFilter () {
    try {
      var sp = new URL(window.location.href).searchParams;
      var keys = Array.from(sp.keys());
      for (var i = 0; i < keys.length; i++) {
        if (keys[i].indexOf('filter.p.m.custom.fitment_') === 0) return true;
      }
      return false;
    } catch (err) { return false; }
  }

  function updateCollectionVehicleBanner () {
    var banners = document.querySelectorAll('[data-collection-vehicle-banner]');
    if (banners.length === 0) return;
    var vehicle = (window.HHymm && window.HHymm.getStoredVehicle) ? window.HHymm.getStoredVehicle() : null;
    var hasFilter = urlHasFitmentFilter();

    var label = vehicle ? [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ') : '';
    banners.forEach(function (banner) {
      var nameEl = banner.querySelector('[data-collection-vehicle-name]');
      if (vehicle && label && !hasFilter) {
        if (nameEl) nameEl.textContent = label;
        banner.dataset.vehicle = label;
        banner.removeAttribute('hidden');
      } else {
        if (nameEl) nameEl.textContent = '';
        banner.dataset.vehicle = '';
        banner.setAttribute('hidden', '');
      }
    });
  }

  function initCollectionVehicleBanner () {
    var banner = document.querySelector('[data-collection-vehicle-banner]');
    if (!banner) return; // not on a collection surface

    // Apply → redirect to filtered URL on current collection. Helper's
    // second arg pins destination to current href (vs default
    // /collections/all-in-stock-items routing on non-collection pages).
    var applyBtn = banner.querySelector('[data-collection-vehicle-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var vehicle = window.HHymm && window.HHymm.getStoredVehicle ? window.HHymm.getStoredVehicle() : null;
        if (!vehicle) return;
        window.location.href = buildVehicleFilterUrl(vehicle, window.location.href);
      });
    }

    // Change → open cart-vehicle-modal. Modal lives on every page (cart
    // drawer parent + standalone /cart) — same instance, reused here.
    // initCartVehicleBar wires the modal's lifecycle (open/close, focus,
    // YMM cascading dropdowns, submit→setStoredVehicle); we just trigger
    // the open. If the modal element isn't on the page (defensive) the
    // change button is a no-op rather than throwing.
    var changeBtn = banner.querySelector('[data-collection-vehicle-change]');
    if (changeBtn) {
      changeBtn.addEventListener('click', function () {
        var modal = document.querySelector('[data-cart-vehicle-modal]');
        if (!modal) return;
        modal.dataset.open = 'true';
        modal.setAttribute('aria-hidden', 'false');
        var firstSelect = modal.querySelector('[data-cart-vehicle-year]');
        if (firstSelect) firstSelect.focus({ preventScroll: true });
      });
    }

    // Clear → wipe stored vehicle. hh:vehicle-changed fires from
    // HHymm.clearStoredVehicle(); updateCollectionVehicleBanner listener
    // hides the banner via the no-vehicle branch.
    var clearBtn = banner.querySelector('[data-collection-vehicle-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (window.HHymm && typeof window.HHymm.clearStoredVehicle === 'function') {
          window.HHymm.clearStoredVehicle();
        }
      });
    }

    updateCollectionVehicleBanner();
    document.addEventListener('hh:vehicle-changed', updateCollectionVehicleBanner);
  }

  // ---------------------------------------------------------------
  // Collection stranded-filter recovery (Phase 1 QA finding 3.A fix,
  // 2026-05-10; path (e) per Steve direction).
  //
  // When a buyer applies a fitment filter URL to a collection that
  // returns zero matching products, Shopify's collection.filters object
  // does NOT mark the filter as "active" (active_values stays empty)
  // because no product in the collection satisfies the filter. As a
  // result, the Liquid `has_active_filters` check returns false, and
  // the page falls into the `zero-products` empty state ("No parts
  // here yet.") — confusing because the category isn't empty; the
  // FILTER narrowed it to zero.
  //
  // Liquid can't see query strings (request.path doesn't expose them),
  // so the recovery has to happen at JS render time. We detect the
  // condition: zero-products empty state + URL contains any
  // filter.p.m.custom.fitment_* param, and rewrite the empty-state
  // copy + insert a "Clear all filters" link.
  //
  // Scoped to fitment_* params specifically (per Steve verification
  // request) — does NOT trigger on sort params, _ab/_fd/_sc preview
  // params, or non-fitment filters. Avoids confusing UX in scenarios
  // where URL has params but page is empty for non-filter reasons.
  // ---------------------------------------------------------------
  function initCollectionStrandedFilterRecovery () {
    var emptyState = document.querySelector('[data-hh-collection-empty="zero-products"]');
    if (!emptyState) return;

    // Scope-narrow detection: only trigger on fitment URL filter presence
    var hasFitmentFilter = false;
    try {
      var sp = new URL(window.location.href).searchParams;
      var keys = Array.from(sp.keys());
      for (var i = 0; i < keys.length; i++) {
        if (keys[i].indexOf('filter.p.m.custom.fitment_') === 0) { hasFitmentFilter = true; break; }
      }
    } catch (err) { return; }
    if (!hasFitmentFilter) return;

    // Rewrite headline + message
    var title = emptyState.querySelector('.hh-collection-empty-state__title');
    var message = emptyState.querySelector('.hh-collection-empty-state__message');
    if (title) title.textContent = 'No parts match your filters.';
    if (message) message.textContent = 'Try removing a filter to see more results, or clear all filters to see everything in this category.';

    // Insert Clear-filters link before the existing Browse-all link
    var actions = emptyState.querySelector('.hh-collection-empty-state__actions');
    if (actions) {
      var clearLink = document.createElement('a');
      clearLink.className = 'hh-collection-empty-state__action hh-collection-empty-state__action--primary';
      clearLink.href = window.location.pathname; // bare collection URL — strips ALL query params
      clearLink.textContent = 'Clear all filters';
      // Demote existing Browse link from --primary if it has that modifier (visual hierarchy preservation)
      var existingPrimary = actions.querySelector('.hh-collection-empty-state__action--primary');
      if (existingPrimary) existingPrimary.classList.remove('hh-collection-empty-state__action--primary');
      actions.insertBefore(clearLink, actions.firstChild);
    }
  }

  // ----- Cart drawer (3.5) -----
  // Slide-in cart panel triggered by header cart icon click. Mirrors
  // initCollectionFilterDrawer (3c-5) for scroll-lock + focus-trap +
  // ESC/outside-tap close. Differences from filter drawer:
  //   - Trigger is <a href="/cart">, not <button> — preventDefault on click
  //     when JS attaches; href is the no-JS fallback.
  //   - Both `aria-hidden` AND `inert` toggle in sync (Decision 8-A in plan).
  //   - Focus moves to close button on open (cart context: clearest exit).
  //   - Idempotency guard — protects against double-init edge case (parent
  //     plan §3 risk 3.5).
  // Subsequent sub-steps extend this function:
  //   3.5-2: AJAX add-to-cart from PDP form intercept; SRA re-render.
  //   3.5-3: qty stepper + remove handlers via /cart/change.js.
  //   3.5-5: GA4 view_cart event on openDrawer (with debounce).
  function initCartDrawer () {
    var aside = document.getElementById('hh-cart-drawer');
    var trigger = document.querySelector('[data-hh-cart-drawer-open]');
    var scrim = aside && aside.querySelector('[data-hh-cart-drawer-scrim]');
    var closeBtn = aside && aside.querySelector('[data-hh-cart-drawer-close]');
    if (!trigger || !aside) return;
    if (aside.dataset.hhInited === 'true') return;
    aside.dataset.hhInited = 'true';

    var savedScrollY = 0;

    function openDrawer () {
      // Idempotent — re-calling on already-open drawer would overwrite savedScrollY
      // to 0 (body is position:fixed, so window.scrollY is 0), corrupting close-time
      // restoration. 3.5-2 introduces re-open scenarios (AJAX add while drawer open).
      if (aside.getAttribute('data-open') === 'true') return;
      // Save scroll position, lock body via position:fixed (iOS Safari-safe; mirrors filter drawer).
      savedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      aside.setAttribute('data-open', 'true');
      aside.removeAttribute('aria-hidden');
      aside.removeAttribute('inert');
      if (scrim) {
        scrim.removeAttribute('hidden');
        scrim.setAttribute('data-open', 'true');
      }
      trigger.setAttribute('aria-expanded', 'true');
      // preventScroll: true required — default focus() behavior scrolls focused
      // element into view even when already visible, which conflicts with the
      // position-fixed scroll-lock restoration pattern. Without preventScroll,
      // window.scrollTo() in the close path is silently overridden by the
      // trigger.focus() side effect. Discovered at 3.5-2 audit; applies to all
      // drawer focus calls during open/close transitions.
      // Focus the close button on open — clearest exit signal for cart context.
      if (closeBtn) closeBtn.focus({ preventScroll: true });

      // GA4 view_cart event on drawer open (3.5-5). Decision 1-A: single-fire
      // per pageview; viewCartFiredThisPageview gate skips duplicate when
      // /cart pageview already fired (initCartView path).
      if (!viewCartFiredThisPageview) {
        viewCartFiredThisPageview = true;
        var items = buildFullCartItems(aside);
        fireDataLayerEvent('view_cart', {
          currency: 'USD',
          value: readCartTotalFromDom(aside),
          items: items
        });
      }
    }

    function closeDrawer () {
      // Restore body + scroll position, return focus to trigger, re-mute a11y tree.
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, savedScrollY);
      aside.setAttribute('data-open', 'false');
      aside.setAttribute('aria-hidden', 'true');
      aside.setAttribute('inert', '');
      if (scrim) {
        scrim.setAttribute('data-open', 'false');
        // Re-hide for transition end; keeps scrim removable from a11y tree.
        // 250ms matches --hh-motion-drawer for in-sync visual + a11y completion.
        setTimeout(function () {
          if (scrim.getAttribute('data-open') === 'false') scrim.setAttribute('hidden', '');
        }, 250);
      }
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({ preventScroll: true });
    }

    // Trigger is <a href="/cart"> — preventDefault intercepts; href stays as no-JS fallback.
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
    if (scrim) scrim.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && aside.getAttribute('data-open') === 'true') {
        e.preventDefault();
        closeDrawer();
      }
    });

    // Focus trap inside drawer when open. Tab cycles forward; Shift+Tab cycles back.
    aside.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (aside.getAttribute('data-open') !== 'true') return;
      var focusables = aside.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus({ preventScroll: true });
      }
    });

    // Expose drawer open/close to other module functions (3.5-2 AJAX add-to-cart,
    // 3.5-3 mutation handlers). Assigned post-listener-setup so consumers don't
    // race against handler attachment.
    cartDrawer = { open: openDrawer, close: closeDrawer };
  }

  // ----- AJAX add-to-cart (3.5-2) -----
  // Intercepts PDP form submit, fetches /cart/add.js, refreshes cart drawer
  // via SRA, syncs header count, opens drawer on success. JS-disabled buyers
  // fall back to native form-POST (action stays /cart/add → 302 to /cart, a
  // 404 until 3.5-4 — accepted gap per parent plan Risk 3.3).
  //
  // Subsequent sub-step extension hooks:
  //   3.5-3: cartDrawerRefresh() reused for /cart/change.js qty + remove
  //   3.5-4: cartDrawerRefresh() extends to /cart page section refresh
  //   3.5-5: GA4 dataLayer events fire at named comment hooks below

  // SRA extraction couples to sections/cart-drawer.liquid panel layout:
  //   - .hh-cart-drawer__header (preserved; close button reference stays attached)
  //   - .hh-cart-drawer__error (preserved; managed separately by setError/clearError)
  //   - .hh-cart-drawer__items / .hh-cart-empty (replaced from SRA response)
  //   - .hh-cart-drawer__footer (replaced from SRA response)
  // If panel structure changes (Phase 4+), update extraction selectors here.
  function cartDrawerRefresh () {
    return fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshPanel = doc.querySelector('.hh-cart-drawer__panel');
        var currentPanel = document.querySelector('#hh-cart-drawer .hh-cart-drawer__panel');
        if (!freshPanel || !currentPanel) return;

        // Items list scrollTop preservation added at 3.5-3 — mutations within
        // drawer would lose scroll position without it. Initial 3.5-2
        // implementation didn't need this since AJAX add-from-PDP was the only
        // flow (drawer always opens fresh; no pre-existing scroll to preserve).
        var currentItems = currentPanel.querySelector('.hh-cart-drawer__items');
        var capturedScroll = currentItems ? currentItems.scrollTop : null;

        // Selective replacement: header + error region preserved (Decision 3-A
        // close-button reference + Decision 6-A error region survive refresh).
        var preservedClasses = ['hh-cart-drawer__header', 'hh-cart-drawer__error'];
        var toRemove = [];
        Array.prototype.forEach.call(currentPanel.children, function (child) {
          var classList = child.classList;
          var isPreserved = preservedClasses.some(function (c) { return classList.contains(c); });
          if (!isPreserved) toRemove.push(child);
        });
        toRemove.forEach(function (n) { n.remove(); });

        // Append fresh non-preserved children (cloneNode to detach from parsed doc)
        Array.prototype.forEach.call(freshPanel.children, function (child) {
          var classList = child.classList;
          var isPreserved = preservedClasses.some(function (c) { return classList.contains(c); });
          if (isPreserved) return;
          currentPanel.appendChild(child.cloneNode(true));
        });

        // Drawer header is preserved (close button reference + listener stays attached),
        // but the count span text inside it is stale (server rendered at page load).
        // Patch in fresh count text from SRA response so visible "(N)" + SR string update.
        // Without this, cartHeaderCountSync would read stale text and skip header sync.
        var freshCountEl = freshPanel.querySelector('[data-hh-cart-count]');
        var currentCountEl = currentPanel.querySelector('[data-hh-cart-count]');
        if (freshCountEl && currentCountEl) {
          currentCountEl.textContent = freshCountEl.textContent;
        }
        // SR count span is conditionally rendered (count > 0 only); insert if absent.
        var freshSrEl = freshPanel.querySelector('[data-hh-cart-count-sr]');
        var currentSrEl = currentPanel.querySelector('[data-hh-cart-count-sr]');
        if (freshSrEl && currentSrEl) {
          currentSrEl.textContent = freshSrEl.textContent;
        } else if (freshSrEl && !currentSrEl && currentCountEl) {
          // 0 → N transition: insert SR span after the visible count
          currentCountEl.parentNode.insertBefore(freshSrEl.cloneNode(true), currentCountEl.nextSibling);
        } else if (!freshSrEl && currentSrEl) {
          // N → 0 transition: remove SR span
          currentSrEl.remove();
        }

        cartHeaderCountSync();

        // Restore items scroll position. New items list may not exist if cart
        // became empty (last item removed → empty state rendered); guard for null.
        var newItems = currentPanel.querySelector('.hh-cart-drawer__items');
        if (newItems && capturedScroll != null) {
          newItems.scrollTop = capturedScroll;
        }
      });
  }

  // /cart page section refresh helper (3.5-4) — parallel to cartDrawerRefresh
  // for the /cart standalone page surface. Replaces the entire `[data-hh-cart-page]`
  // section content from SRA response. Called alongside cartDrawerRefresh on
  // /cart page mutations to preserve the drawer-as-source-of-truth invariant
  // for cartHeaderCountSync (3.5-2 invariant).
  //
  // No scroll preservation here: /cart page uses full-document scroll, not
  // internal items-list scroll. Browser preserves window.scrollY across DOM
  // mutations within <main>. If future layout adds internal scroll on items
  // column (e.g., sticky summary right column), carry forward
  // cartDrawerRefresh scroll-preservation pattern.
  function cartPageRefresh () {
    var current = document.querySelector('[data-hh-cart-page]');
    if (!current) return Promise.resolve();
    return fetch('/cart?section_id=main-cart', { headers: { 'Accept': 'text/html' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-hh-cart-page]');
        if (!fresh) return;
        // Replace entire section content; no preservation needed (no listener-bound
        // elements on /cart page — all listeners are document-delegated post-3.5-4).
        current.innerHTML = fresh.innerHTML;
      });
  }

  // Header badge structure mirrors sections/header.liquid:79-82:
  //   <span class="hh-header__cart-count" aria-hidden="true">N</span>
  //   <span class="visually-hidden">N items</span>
  // Keep in sync if header.liquid badge layout changes.
  function cartHeaderCountSync () {
    var drawerCountEl = document.querySelector('#hh-cart-drawer [data-hh-cart-count]');
    if (!drawerCountEl) return;
    // Drawer text format: "(3)" when count > 0, empty string when 0
    var match = drawerCountEl.textContent.match(/(\d+)/);
    var count = match ? parseInt(match[1], 10) : 0;

    var headerLink = document.querySelector('[data-hh-cart-drawer-open]');
    if (!headerLink) return;
    var existingBadge = headerLink.querySelector('.hh-header__cart-count');
    var existingSr = existingBadge && existingBadge.nextElementSibling;
    var existingSrIsHidden = existingSr && existingSr.classList.contains('visually-hidden');

    if (count === 0) {
      if (existingBadge) existingBadge.remove();
      if (existingSrIsHidden) existingSr.remove();
      return;
    }

    var srText = count + ' ' + (count === 1 ? 'item' : 'items');

    if (existingBadge) {
      existingBadge.textContent = String(count);
      if (existingSrIsHidden) existingSr.textContent = srText;
      return;
    }

    // 0 → N transition: insert badge structure
    var badge = document.createElement('span');
    badge.className = 'hh-header__cart-count';
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = String(count);
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = srText;
    headerLink.appendChild(badge);
    headerLink.appendChild(sr);
  }

  function initAjaxAddToCart () {
    var atcBtn = document.querySelector('[data-atc]:not([disabled])');
    if (!atcBtn) return;
    var form = atcBtn.closest('form');
    if (!form) return;
    if (form.dataset.hhAjaxAddInited === 'true') return;
    form.dataset.hhAjaxAddInited = 'true';

    // Per-form generation counter (closure-local). Each form on a page gets its
    // own counter; rapid clicks on the same form coalesce via button-disable +
    // counter check; cross-form races (Phase 4+ multi-ATC pages) stay isolated.
    var generationCounter = 0;

    var errorRegion = document.querySelector('#hh-cart-drawer [data-hh-cart-drawer-error]');

    function setError (message) {
      if (!errorRegion) return;
      errorRegion.textContent = message;
      errorRegion.removeAttribute('hidden');
    }
    function clearError () {
      if (!errorRegion) return;
      errorRegion.textContent = '';
      errorRegion.setAttribute('hidden', '');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();
      var thisGeneration = ++generationCounter;
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      }).then(function (res) {
        return res.json().then(function (body) { return { ok: res.ok, body: body }; });
      }).then(function (result) {
        if (thisGeneration !== generationCounter) return;
        if (!result.ok) {
          var msg = (result.body && (result.body.description || result.body.message)) || 'Could not add to cart. Try again.';
          setError(msg);
          // Decision 6-A: drawer auto-opens on error path to surface the alert
          if (cartDrawer) cartDrawer.open();
          return;
        }
        // GA4 add_to_cart event (3.5-5). Source data from /cart/add.js response.
        // Decision 4-A: vendor sourced from response (server-authoritative).
        var added = result.body || {};
        var addedItem = {
          item_id: String(added.product_id || added.id || ''),
          item_name: added.product_title || added.title || '',
          item_brand: added.vendor || '',
          price: (added.final_price || added.price || 0) / 100,
          quantity: added.quantity || 1
        };
        fireDataLayerEvent('add_to_cart', {
          currency: 'USD',
          value: addedItem.price * addedItem.quantity,
          items: [addedItem]
        });
        return cartDrawerRefresh().then(function () {
          if (thisGeneration !== generationCounter) return;
          if (cartDrawer) cartDrawer.open();
        });
      }).catch(function () {
        if (thisGeneration !== generationCounter) return;
        setError('Network error. Try again.');
        if (cartDrawer) cartDrawer.open();
      }).then(function () {
        if (thisGeneration !== generationCounter) return;
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-busy');
      });
    });
  }

  // ----- Cart mutation handlers (3.5-3) -----
  // Qty stepper (+/−), direct qty input edit, and remove button — all bind to
  // the inert DOM hooks reserved at 3.5-1 and mutate via /cart/change.js.
  // cartDrawerRefresh from 3.5-2 reused for post-mutation section render +
  // header count sync; cartDrawer module reference reused for drawer.open()
  // (drawer assumed already open since mutations are user-initiated from
  // inside the drawer; but defensive .open() ensures error/clamp cases surface
  // even if buyer somehow triggered a mutation while drawer was closed).
  //
  // Stepper math intentionally duplicated from initQty (PDP) per 3.5-3 plan §5
  // Decision 1. PDP qty is form-side prep; cart qty is server-mutation trigger
  // — same math, different meaning. Distinct selectors (data-cart-qty-* vs
  // data-qty-*) keep grep precise. If future code adds a third stepper context
  // (Phase 4+ homepage quick-add, order-edit page), revisit shared abstraction
  // with empirical knowledge of all three contexts.
  function initCartMutations () {
    var drawer = document.getElementById('hh-cart-drawer');
    if (!drawer) return;
    if (drawer.dataset.hhMutationsInited === 'true') return;
    drawer.dataset.hhMutationsInited = 'true';

    var errorRegion = drawer.querySelector('[data-hh-cart-drawer-error]');

    function setError (message) {
      if (!errorRegion) return;
      errorRegion.textContent = message;
      errorRegion.removeAttribute('hidden');
    }
    function clearError () {
      if (!errorRegion) return;
      errorRegion.textContent = '';
      errorRegion.setAttribute('hidden', '');
    }

    // Per-line generation counter — closure-local Map keyed by line key.
    // Each mutation increments its line's counter; only the latest fetch wins
    // post-response handling. Protects under concurrent mutations on different
    // lines (line A in-flight + line B mutated → both end at correct state)
    // AND same-line races (+ then immediately remove on same line → remove wins).
    var generations = new Map();

    // Mutation helper — fetch /cart/change.js, gate on per-line generation,
    // dispatch to cartDrawerRefresh on success, surface inline error otherwise.
    // requestedQuantity passed so we can detect server clamp (response qty < requested).
    //
    // 3.5-4: routes refresh based on mutation context (ancestor walk per
    // Decision 5-A). On drawer: cartDrawerRefresh only. On /cart page: both
    // cartPageRefresh AND cartDrawerRefresh — drawer's count span is the
    // 3.5-2-locked source-of-truth for cartHeaderCountSync; refreshing both
    // preserves that invariant. Drawer fetch is cheap; single-fetch
    // optimization via multi-section query string logged for Phase 9.
    function refreshForContext (lineEl) {
      var onCartPage = lineEl && lineEl.closest('[data-hh-cart-page]');
      if (onCartPage) {
        return Promise.all([cartPageRefresh(), cartDrawerRefresh()]);
      }
      return cartDrawerRefresh();
    }

    function cartLineUpdate (lineKey, requestedQuantity, lineEl) {
      clearError();
      var thisGeneration = (generations.get(lineKey) || 0) + 1;
      generations.set(lineKey, thisGeneration);
      if (lineEl) lineEl.setAttribute('aria-busy', 'true');

      // Capture pre-mutation line item data (Decision 5-A) — needed for
      // remove_from_cart event payload. By the time /cart/change.js returns
      // for a quantity=0 mutation, the response body's items[] no longer
      // contains the removed line.
      var preMutationItem = (requestedQuantity === 0 && lineEl) ? buildCartItemFromLine(lineEl) : null;

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: requestedQuantity })
      }).then(function (res) {
        return res.json().then(function (body) { return { ok: res.ok, body: body }; });
      }).then(function (result) {
        if (generations.get(lineKey) !== thisGeneration) return;
        if (!result.ok) {
          var msg = (result.body && (result.body.description || result.body.message)) || 'Could not update cart. Try again.';
          setError(msg);
          if (cartDrawer) cartDrawer.open();
          // Refresh drawer to restore input/qty to server-truth — without this,
          // the user-typed value (e.g. "5") sticks in the input while server
          // cart still shows the prior qty. Drawer state diverging from server
          // state is the bug class caught at 3.5-3 audit (Shopify returns 422
          // for stock-exceeded change requests; SRA refresh re-renders the
          // input with actual server value).
          return refreshForContext(lineEl);
        }
        // Inventory clamp detection: response.quantity < requested means server
        // reduced qty due to insufficient stock. Surface inline (200 path, not
        // 422 — different signal than 3.5-2's hard-error path).
        // Find the line in the response: response.items is an array; match by key.
        if (requestedQuantity > 0 && result.body && result.body.items) {
          var responseLine = result.body.items.find(function (i) { return i.key === lineKey; });
          if (responseLine && responseLine.quantity < requestedQuantity) {
            setError('Only ' + responseLine.quantity + ' available — quantity adjusted.');
          }
        }
        // GA4 remove_from_cart event (3.5-5) when requestedQuantity === 0.
        // Uses pre-mutation item data captured at start of cartLineUpdate
        // (response body no longer contains the removed line).
        if (requestedQuantity === 0 && preMutationItem) {
          fireDataLayerEvent('remove_from_cart', {
            currency: 'USD',
            value: preMutationItem.price * preMutationItem.quantity,
            items: [preMutationItem]
          });
        }
        return refreshForContext(lineEl).then(function () {
          if (generations.get(lineKey) !== thisGeneration) return;
        });
      }).catch(function () {
        if (generations.get(lineKey) !== thisGeneration) return;
        setError('Network error. Try again.');
        if (cartDrawer) cartDrawer.open();
      }).then(function () {
        if (generations.get(lineKey) !== thisGeneration) return;
        if (lineEl) lineEl.removeAttribute('aria-busy');
      });
    }

    // Debounce helper for direct qty input edits.
    var debounceTimers = new Map();  // line key → timer id
    function debouncedUpdate (lineKey, quantity, lineEl, delay) {
      var existing = debounceTimers.get(lineKey);
      if (existing) clearTimeout(existing);
      var timer = setTimeout(function () {
        debounceTimers.delete(lineKey);
        cartLineUpdate(lineKey, quantity, lineEl);
      }, delay);
      debounceTimers.set(lineKey, timer);
    }

    // 3.5-4 refactor: document-delegated listeners (was drawer-bound at 3.5-3).
    // Selectors are cart-prefixed (data-cart-qty-* vs PDP's data-qty-*) so
    // delegation namespace is clean — drawer + /cart page surfaces caught;
    // PDP qty stepper unaffected. Future stepper contexts (Phase 4+ quick-add)
    // should use distinct prefixed hooks to preserve the namespace boundary.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-qty-decrement], [data-cart-qty-increment]');
      if (!btn) return;
      var qtyContainer = btn.closest('[data-cart-qty]');
      var input = qtyContainer && qtyContainer.querySelector('[data-cart-qty-input]');
      if (!input) return;
      var current = parseInt(input.value, 10);
      if (!Number.isFinite(current)) current = 1;
      var min = parseInt(input.min, 10);
      if (!Number.isFinite(min)) min = 1;
      var next = btn.matches('[data-cart-qty-decrement]')
        ? Math.max(min, current - 1)
        : current + 1;
      if (next === current) return;
      input.value = next;
      // Brief button disable for rapid-click defense; cleared by aria-busy clear in cartLineUpdate
      btn.disabled = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () { btn.disabled = false; }, 150);
    });

    // Change listener on qty input — debounced AJAX trigger.
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      var lineKey = input.dataset.lineKey;
      if (!lineKey) return;
      var quantity = parseInt(input.value, 10);
      if (!Number.isFinite(quantity) || quantity < 1) {
        input.value = 1;
        quantity = 1;
      }
      var lineEl = input.closest('.hh-cart-line');
      debouncedUpdate(lineKey, quantity, lineEl, 250);
    });

    // Delegated click on remove button — immediate remove (Decision 5-A).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-line-remove]');
      if (!btn) return;
      var lineKey = btn.dataset.lineKey;
      if (!lineKey) return;
      var lineEl = btn.closest('.hh-cart-line');
      cartLineUpdate(lineKey, 0, lineEl);
    });

    // /cart page form intentionally has no submit listener for QTY MUTATIONS.
    // JS-on flow handles qty mutations via individual change events (debounced);
    // native form-POST is the JS-off path only. .no-js CSS gate keeps Update
    // button hidden for JS-on buyers, so they never reach native qty submit.
    //
    // begin_checkout submit listener (3.5-5) IS document-delegated below — it
    // catches the Checkout button submit on both drawer + /cart page forms,
    // fires GA4 event BEFORE form proceeds to /checkout. Different from qty
    // mutations: checkout is a form-POST flow we want to keep (Shopify's
    // canonical /checkout entry), so we observe rather than intercept.
  }

  // ----- /cart pageview view_cart event (3.5-5) -----
  // Fires once per pageview when buyer lands on /cart route. Sets the
  // viewCartFiredThisPageview flag so subsequent drawer-opens skip duplicate
  // (Decision 1-A: single-fire per pageview).
  function initCartView () {
    if (!document.body.classList.contains('template-cart')) return;
    if (viewCartFiredThisPageview) return;
    viewCartFiredThisPageview = true;
    var pageEl = document.querySelector('[data-hh-cart-page]');
    var items = buildFullCartItems(pageEl);
    fireDataLayerEvent('view_cart', {
      currency: 'USD',
      value: readCartTotalFromDom(pageEl),
      items: items
    });
  }

  // ----- Collection view_item_list event (9-β / restructured 2026-05-11) -----
  // Reads server-injected ecommerce payload from <script data-hh-view-item-list>
  // emitted by sections/main-collection.liquid inside the paginate.items > 0
  // branch. Fires via fireDataLayerEvent helper for consistency with the 4
  // Phase 3.5 cart events (view_cart / add_to_cart / remove_from_cart /
  // begin_checkout). Server-render → DOM JSON → JS parse → helper fire.
  //
  // Skip-by-placement: if the section omits the JSON block (empty collection
  // or filter-result-zero state), querySelector returns null + we return
  // early. No template-class check needed.
  //
  // GA4 forwarding: Shopify Channel App auto-fires 7 standard ecommerce
  // events to GA4 but NOT view_item_list (empirically verified 5/11 via
  // GA4 Realtime sweep on collection page). Theme container GTM-5QBZJ7RR
  // forwards this event to GA4 via Custom Event trigger + GA4 Event tag
  // (Steve admin configures post-push). See docs/deferred-work-registry.md
  // §596-620 for full architecture context.
  function initCollectionViewItemList () {
    var dataEl = document.querySelector('script[data-hh-view-item-list]');
    if (!dataEl) return;
    try {
      var ecommerce = JSON.parse(dataEl.textContent);
      fireDataLayerEvent('view_item_list', ecommerce);
    } catch (e) {
      console.warn('[collection-view_item_list] payload parse failed:', e);
    }
  }

  // ----- begin_checkout document-delegated submit listener (3.5-5) -----
  // Catches click + keyboard Enter (both fire submit event). Fires BEFORE
  // form proceeds to /checkout. dataLayer.push is synchronous (queues event);
  // GTM beacon transport handles in-flight transmission across navigation.
  // Refinement 11.D: race-prone-timing tested at 3.5-6 via GA4 DebugView.
  function initBeginCheckout () {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var checkoutBtn = form.querySelector('button[name="checkout"]');
      if (!checkoutBtn) return;
      // Find the cart container — drawer or /cart page; full cart items[] from there
      var rootEl = form.closest('#hh-cart-drawer, [data-hh-cart-page]');
      var items = buildFullCartItems(rootEl);
      fireDataLayerEvent('begin_checkout', {
        currency: 'USD',
        value: readCartTotalFromDom(rootEl),
        items: items
      });
      // Don't preventDefault — form proceeds to /checkout normally.
    });
  }

  // Reset view_cart fire gate on bfcache restoration (refinement 11.C).
  // Browsers restoring from bfcache preserve closure-local state, which
  // would mean view_cart never re-fires for buyers who use back-forward.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) viewCartFiredThisPageview = false;
  });

  // ----- Consent signal (Phase 5 follow-up; companion to Privacy v1.4) -----
  // Reads hh_ads_optout cookie + navigator.globalPrivacyControl on every page;
  // pushes consent_state to dataLayer so GTM ad tags can gate firing on consent.
  // GTM ad tag configuration ships with the pixel-ship successor worktree;
  // this signal is preparatory infrastructure that ships now alongside the
  // /pages/data-sharing-opt-out widget.
  var HH_OPTOUT_COOKIE = 'hh_ads_optout';

  function hhReadOptOutCookie () {
    var match = document.cookie.split('; ').find(function (row) {
      return row.indexOf(HH_OPTOUT_COOKIE + '=') === 0;
    });
    return match ? match.split('=')[1] : null;
  }

  function hhDetectGpc () {
    return navigator.globalPrivacyControl === true;
  }

  function hhPushConsentState () {
    var optedOut = hhReadOptOutCookie() === '1';
    var gpc = hhDetectGpc();
    var denied = optedOut || gpc;
    window.dataLayer = window.dataLayer || [];
    // Custom event for non-Google tags (Meta Pixel etc.) consumed via GTM
    // Custom Event trigger on `advertising_consent`.
    window.dataLayer.push({
      event: 'consent_state',
      advertising_consent: denied ? 'denied' : 'granted'
    });
    // Consent Mode v2 update for Google tags (Google Ads, GA4).
    // Default declaration in snippets/analytics.liquid sets initial state
    // from cookie+GPC at page load; this propagates within-session
    // preference changes (user clicks opt-out / opt-in on
    // /pages/your-privacy-choices). gtag is defined globally in
    // analytics.liquid; using arguments-object shape via gtag() is the
    // GTM-canonical form (dataLayer.push of a literal array is not
    // recognized by GTM as a Consent Mode update).
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'ad_storage': denied ? 'denied' : 'granted',
        'ad_user_data': denied ? 'denied' : 'granted',
        'ad_personalization': denied ? 'denied' : 'granted'
      });
    }
    // Shopify Customer Privacy API — propagates consent to Shopify-managed
    // pixels installed via Sales Channel Apps (Facebook & Instagram Channel,
    // Microsoft Channel, etc.). Without this, the Meta Pixel installed via
    // Shopify Channel App would continue firing for opted-out visitors
    // because Shopify reads its own Customer Privacy state, not our
    // hh_ads_optout cookie.
    //
    // Categories:
    //   marketing      — advertising cookies (Meta Pixel, etc.)
    //   analytics      — analytics cookies (GA4, Dynatrace) — stays granted
    //                    per Privacy Policy v1.4 §5 Analytics cookies
    //   preferences    — site preferences (essential UX)
    //   sale_of_data   — CCPA "sale of data" opt-out signal
    //
    // Defensive: window.Shopify may not be loaded yet (script load order is
    // not deterministic). When available, push consent; when not, log + skip.
    // Shopify Channel App tags re-read consent state on every event fire,
    // so a later push catches them up.
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          marketing: !denied,
          analytics: true,
          preferences: true,
          sale_of_data: !denied
        }, function () { /* callback no-op; Shopify confirms write */ });
      } catch (e) {
        console.warn('[consent] Shopify.customerPrivacy.setTrackingConsent failed:', e);
      }
    }
  }

  function initConsentSignal () {
    hhPushConsentState();
  }

  // ----- Your Privacy Choices page (Phase 5 follow-up) -----
  // Three-state UI on /pages/data-sharing-opt-out: default (opted-in) /
  // opted-out / gpc. Cookie hh_ads_optout=1 persists opt-out preference
  // for 1 year, host-only, SameSite=Lax. Button clicks toggle the cookie
  // and refresh the UI + re-push consent_state to dataLayer.
  function initChoicesPage () {
    var page = document.querySelector('[data-choices-page]');
    if (!page) return;

    var COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

    function setOptOut () {
      document.cookie = HH_OPTOUT_COOKIE + '=1; Path=/; Max-Age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
    }

    function clearOptOut () {
      document.cookie = HH_OPTOUT_COOKIE + '=; Path=/; Max-Age=0; SameSite=Lax';
    }

    function currentState () {
      if (hhDetectGpc()) return 'gpc';
      if (hhReadOptOutCookie() === '1') return 'opted-out';
      return 'default';
    }

    function showState (stateName) {
      page.querySelectorAll('[data-choices-state]').forEach(function (panel) {
        var matches = panel.getAttribute('data-choices-state') === stateName;
        panel.hidden = !matches;
        panel.setAttribute('aria-hidden', String(!matches));
      });
    }

    function refresh () {
      showState(currentState());
      hhPushConsentState();
    }

    page.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-choices-action]');
      if (!trigger) return;
      var action = trigger.getAttribute('data-choices-action');
      if (action === 'opt-out') setOptOut();
      if (action === 'opt-in') clearOptOut();
      refresh();
    });

    refresh();
  }

  ready(function () {
    initAnnouncement();
    initMobileNav();
    initSpecCopy();
    initPdpGallery();
    initQty();
    initVariants();
    initFitmentStatus();
    initVehicleBanner();
    initPdpFitmentLink();
    initPdpStickyAtc();
    initPdpRelated();
    initCollectionSort();
    initCollectionFilters();
    initFilterShowMore();
    initCollectionYmmPicker();
    initCollectionFilterDrawer();
    initLoadMore();
    initCollectionVehicleBanner();
    initCollectionStrandedFilterRecovery();
    initCartDrawer();
    initCartVehicleBar();
    initYmmCard({ prefix: 'cart-empty' });
    initYmmCard({ prefix: 'hero' });
    initAjaxAddToCart();
    initCartMutations();
    initCartView();
    initCollectionViewItemList();
    initBeginCheckout();
    initConsentSignal();
    initChoicesPage();
  });
})();
